export default {
    es: {
      message: {
        settings: 'Ajustes',
        deviceId: 'Dispositivo',
        restaurant: 'Restaurante',
        cameraPermission: 'Permiso de cámara',
        flipVertically: 'Modo Periscopio\u2122',
        flipVerticallyHint: 'Endereza la imagen del soporte con espejo',
        periscopeTutorialTitle: 'Colocar el periscopio',
        periscopeTutorialExit: 'Salir',
        periscopeTutorialStepOf: 'Paso {step} de {total}',
        periscopeTutorialBack: 'Atrás',
        periscopeTutorialReplay: 'Ver otra vez',
        periscopeTutorialSettings: 'Cómo colocar el Periscopio\u2122',
        periscopeTutorialSettingsHint: 'Guía paso a paso con tu cámara',
        photoVideoTutorialSettings: 'Cómo hacer buenas fotos',
        photoVideoTutorialSettingsHint: 'Vídeo · {duration}',
        photoVideoTutorialTitle: 'Cómo hacer buenas fotos',
        photoVideoTutorialClose: 'Cerrar',
        photoVideoTutorialRemaining: 'Quedan {time}',
        photoVideoTutorialLoading: 'Cargando el vídeo…',
        photoVideoTutorialPause: 'Pausar',
        photoVideoTutorialPlay: 'Reproducir',
        photoVideoTutorialReplay: 'Ver otra vez',
        photoVideoTutorialRestart: 'Desde el principio',
        photoVideoTutorialErrorTitle: 'No se ha podido cargar el vídeo',
        photoVideoTutorialErrorBody: 'Revisa la conexión a internet y vuelve a intentarlo.',
        photoVideoTutorialRetry: 'Reintentar',
        periscopeTutorialWelcomeTitle: 'Vamos a colocar el periscopio',
        periscopeTutorialWelcomeBody: 'Es el espejo que va pegado en la esquina de la tablet, encima de la cámara. Te llevará unos minutos.',
        periscopeTutorialWelcomeNote: 'Solo sale la primera vez en esta tablet. Lo tienes también en Ajustes.',
        periscopeTutorialWelcomeStart: 'Empezar',
        periscopeTutorialWelcomeAlready: 'Ya está colocado',
        periscopeTutorialNeedsTitle: 'Antes de empezar, busca esto',
        periscopeTutorialNeedsBody: 'En la caja solo viene el periscopio. Lo demás lo pones tú.',
        periscopeTutorialNeedsPeriscope: 'El periscopio',
        periscopeTutorialNeedsAlcohol: 'Alcohol o desengrasante',
        periscopeTutorialNeedsCloth: 'Un paño',
        periscopeTutorialNeedsPencil: 'Un lápiz o rotulador',
        periscopeTutorialNeedsNext: 'Lo tengo',
        periscopeTutorialCleanTitle: 'Limpia la esquina de la cámara',
        periscopeTutorialCleanBody: 'Echa alcohol en el paño y limpia bien la zona donde irá pegado: el borde de la tablet junto a la cámara.',
        periscopeTutorialCleanStrong: 'Si queda grasa, no pega.',
        periscopeTutorialCleanNext: 'Ya está limpio',
        periscopeTutorialPlaceTitle: 'Ponlo en la esquina, sin pegarlo',
        periscopeTutorialPlaceBody: 'La base en el borde y el espejo encima de la cámara.',
        periscopeTutorialPlaceStrong: 'No quites todavía el plástico rojo.',
        periscopeTutorialPlaceInset: 'La cámara mira al espejo y el espejo, a la mesa.',
        periscopeTutorialPlaceCamera: 'Cámara',
        periscopeTutorialPlaceMirror: 'Espejo',
        periscopeTutorialPlaceTable: 'Mesa',
        periscopeTutorialPlaceNext: 'Siguiente',
        periscopeTutorialAlignTitle: 'Muévelo hasta que solo se vea la mesa',
        periscopeTutorialAlignBody: 'Apunta el espejo a la mesa y mueve el periscopio poco a poco.',
        periscopeTutorialAlignStrong: 'No se tiene que mezclar nada, ni arriba ni abajo.',
        periscopeTutorialAlignNext: 'Ya se ve bien',
        periscopeTutorialLiveBadge: 'Foto real · se actualiza sola',
        periscopeTutorialLiveAlt: 'Foto real de la cámara',
        periscopeTutorialLiveStarting: 'Abriendo la cámara…',
        periscopeTutorialLiveError: 'No se puede abrir la cámara.',
        periscopeTutorialLiveRetry: 'Reintentar',
        periscopeTutorialExampleGood: 'Bien: solo la mesa',
        periscopeTutorialExampleBadBottom: 'Mal: se mezcla abajo',
        periscopeTutorialExampleBadTop: 'Mal: se mezcla arriba',
        periscopeTutorialMarkTitle: 'Marca dónde va',
        periscopeTutorialMarkBody: 'Sin moverlo, rodea la base con el lápiz: los dos lados y la parte de atrás.',
        periscopeTutorialMarkNext: 'Ya está marcado',
        periscopeTutorialStickTitle: 'Quita el plástico rojo y pégalo',
        periscopeTutorialStickBody: 'Ponlo justo en la marca.',
        periscopeTutorialStickStrong: 'Aprieta fuerte unos segundos.',
        periscopeTutorialStickNext: 'Ya está pegado',
        periscopeTutorialCheckTitle: 'Comprueba que se ve bien',
        periscopeTutorialCheckBody: '¿Se ve solo la mesa, sin franjas de otra cosa arriba o abajo?',
        periscopeTutorialCheckYes: 'Sí, se ve bien',
        periscopeTutorialCheckNo: 'No, hay que moverlo',
        periscopeTutorialUnstickTitle: 'Despégalo girándolo',
        periscopeTutorialUnstickBody: 'Gira el periscopio sobre sí mismo, una vuelta entera, hasta que se suelte.',
        periscopeTutorialUnstickNext: 'Ya está despegado',
        periscopeTutorialRestickTitle: 'Pégalo otra vez en la marca',
        periscopeTutorialRestickBody: 'Ponlo justo en la marca.',
        periscopeTutorialRestickBad: 'No pega bien',
        periscopeTutorialRetapeTitle: 'Cambia la cinta',
        periscopeTutorialRetapeBody: 'Compra cinta adhesiva de doble cara. Quita la cinta vieja de la base y pega un trozo nuevo del mismo tamaño.',
        periscopeTutorialRetapeNext: 'Ya tiene cinta nueva',
        periscopeTutorialDoneTitle: '¡Periscopio colocado!',
        periscopeTutorialDoneBody: 'Hemos activado el Modo Periscopio\u2122 para que la imagen salga del derecho.',
        periscopeTutorialDoneBody2: 'Ya puedes poner la tablet en su soporte.',
        periscopeTutorialDoneFinish: 'Terminar',
        immersiveViewport: 'Modo inmersivo de cámara',
        immersiveViewportHint: 'La cámara a pantalla completa',
        immersiveViewportModalTitle: 'Modo inmersivo de cámara activado',
        immersiveViewportModalBody: 'La cámara ahora se ve más grande y los botones aparecerán encima de la imagen. Si prefieres volver a la versión anterior, desactiva la opción en Ajustes.',
        immersiveViewportModalButton: 'Entendido',
        signOut: 'Cerrar sesión',
        signOutHint: 'Para volver hará falta el código',
        general: 'General',
        camera: 'Cámara',
        cameraHint: 'Automático usa la trasera',
        signIn: 'Iniciar sesión',
        signingIn: 'Iniciando sesión...',
        queue: 'Cola de subida',
        photo: 'Foto',
        analyze: 'Analizar',
        photoAndAnalyze: 'Foto y analizar',
        retakeReminder: 'Recuerda volver para hacer la foto y analizar',
        retakeReminderTitle: 'Pedido {code} sin corregir',
        retakeReminderBody: 'Vuelve a abrirlo, haz la foto y pulsa Analizar.',
        retakeAimTitle: 'Haz la foto a:',
        retakeAimFoot: 'y pulsa Analizar para continuar',
        avoidDuplicatePhotos: 'Recuerda no repetir la misma foto',
        imagesLeftToUpload: 'Fotos restantes por subir',
        cancelAnalysis: 'Cancelar Análisis',
        back: 'Atrás',
        timeout: 'No se ha podido analizar el contenido del pedido.',
        accept: 'Aceptar',
        analyzing: 'Analizando pedido',
        analysisError: 'Error al analizar el pedido',
        close: 'Cerrar',
        checkOrder: 'Revisar pedido',
        missingItems: 'Productos faltantes',
        notDetected: 'Falta {count} producto | Faltan {count} productos',
        notDetectedSubtitleSingle: 'Revisa el pedido antes de cerrar la bolsa',
        missingCount: 'Falta {count} | Faltan {count}',
        stillContinue: 'Entregar sin corregir',
        stillContinueWarning: 'El cliente puede reclamar',
        addPhotos: 'Corregir y hacer otra foto',
        itemNotDetectedInPhoto: 'Uno de estos productos no se detectó | {count} de estos productos no se detectaron',
        perfect: '¡Todo está perfecto!',
        finalize: 'Finalizar',
        help: 'Ayuda',
        helpPrefill: 'Hola, somos el equipo de cocina de {store}. Necesitamos ayuda con: ',
        noOrders: 'Todavía no tenemos ningún pedido',
        resolution: 'Resolución',
        cameraDefault: 'Automático',
        uploadQueue: 'Cola de subida',
        debug: 'Debug',
        version: 'Versión',
        madeWithLove: 'Hecho con ❤️ en España',
        confirmSignOut: '¿Estás seguro de que deseas cerrar la sesión?',
        reload: 'Recargar',
        clearCache: 'Limpiar caché',
        sessionExpired: 'La sesión ha expirado, redirigiendo al inicio de sesión',
        newServiceWorker: 'Nueva versión detectada. Preparando actualización...',
        errorLoadingSettings: 'Error al cargar la configuración',
        indexedDBCleared: 'Base de datos local limpiada correctamente',
        errorClearingIndexedDB: 'Error al limpiar la base de datos local',
        loading: 'Cargando...',
        startupConnecting: 'Conectando con tu restaurante…',
        loadingTakingLong: 'Está tardando más de lo normal',
        retryingAutomatically: 'Seguimos reintentando automáticamente. No hace falta que hagas nada.',
        startupAutoReloadIn: 'La aplicación se reiniciará sola en {s} s',
        startupRestarting: 'Reiniciando la aplicación…',
        startupFailedTitle: 'No hay conexión',
        startupFailedBody: 'Hemos dejado de reintentar. Comprueba el wifi del restaurante y pulsa Reintentar. Si sigue fallando, avisa a tu encargado.',
        startupDeviceMeta: 'Dispositivo: {id} · v{version}',
        retryStartup: 'Reintentar',
        deviceIdChanged: 'El identificador de este dispositivo ha cambiado. Escribe el identificador nuevo y su código para volver a entrar.',
        otpCode: 'Código OTP',
        needHelp: '¿Necesitas ayuda?',
        loginSuccessful: '¡Inicio de sesión exitoso!',
        sessionExpiredRelogin: 'Tu sesión ha expirado. Por favor, inicia sesión de nuevo.',
        errorOccurred: 'Ha ocurrido un error. Por favor, inténtalo de nuevo.',
        incorrectCredentials: 'No se pudo iniciar sesión. Revisa el dispositivo y el código OTP.',
        userNotFound: 'Error al iniciar sesión: Usuario no encontrado.',
        invalidOTP: 'Error al iniciar sesión: Código OTP inválido.',
        hideTicket: 'Ocultar',
        showTicket: 'Ticket',
        listView: 'Lista',
        groupView: 'Grupo',
        allergiesLabel: 'ALERGIAS',
        commentsLabel: 'COMENTARIOS',
        contentNotAvailable: 'Contenido no disponible',
        uploadTakingTooLong: 'La subida está tardando un poco…',
        analysisTakingTooLong: 'El análisis está tardando más de lo debido\nPor favor, comprueba tu conexión a internet',
        unknown: 'Desconocido',
        unknownOrder: 'Pedido desconocido',
        messageFrom: 'Mensaje de',
        secondsRemaining: 'segundos restantes',
        justNow: 'Hace un momento',
        minuteAgo: 'Hace 1 m',
        minutesAgo: 'Hace {minutes} m',
        // Camera preview literals
        initializingCamera: 'Iniciando cámara...',
        startCamera: 'Iniciar cámara',
        cameraFaultPermissionTitle: 'Falta el permiso de cámara',
        cameraFaultPermissionBlockedBody: 'El navegador tiene la cámara bloqueada para Bronze. Toca el candado que hay junto a la dirección, pon Cámara en «Permitir» y vuelve a intentarlo.',
        cameraFaultPermissionPendingBody: 'El navegador ha pedido permiso para usar la cámara y nadie ha respondido. Toca «Permitir» en el aviso que sale arriba.',
        cameraFaultBusyAppTitle: 'La cámara está ocupada',
        cameraFaultBusyAppBody: 'Otra aplicación del tablet está usando la cámara. Ciérrala desde las apps recientes y vuelve a intentarlo. Si sigue igual, reinicia el tablet.',
        cameraFaultOtherWindowTitle: 'Bronze está abierto dos veces',
        cameraFaultOtherWindowBody: 'Bronze Tracker está abierto en otra ventana o pestaña, y sólo una puede usar la cámara. Cierra la otra y vuelve a intentarlo.',
        cameraFaultNeedsTapTitle: 'Toca para activar la cámara',
        cameraFaultNeedsTapBody: 'El navegador necesita que toques la pantalla para encender la cámara. Toca el botón de abajo.',
        cameraFaultNoCameraTitle: 'No se detecta ninguna cámara',
        cameraFaultNoCameraBody: 'Este tablet no expone ninguna cámara. Comprueba que no esté desactivada en los ajustes del dispositivo.',
        cameraFaultUnknownTitle: 'No se pudo iniciar la cámara',
        cameraFaultUnknownBody: 'Vuelve a intentarlo. Si no arranca, reinicia el tablet y avisa a soporte con el código de abajo.',
        cameraRetryAttempt: 'Reintentando… ({attempt}/{total})',
        cancel: 'Cancelar',
        more: 'más',
        photoDiscarded: 'Foto descartada',
        capturing: 'Capturando...',
        // Manual order
        manualOrderAdd: 'Añadir pedido',
        manualOrderAddFull: 'Añadir pedido manualmente',
        manualOrderTitle: 'Pedido manual',
        manualOrderSelectPlatform: '¿De qué plataforma es el pedido?',
        manualOrderEnterCode: 'Introduce el código del pedido',
        manualOrderEnterCodeN: 'Introduce el código de pedido de {n} dígitos',
        manualOrderEnterCodeCharsN: 'Introduce el código de pedido de {n} caracteres',
        manualOrderEnterOrderSuffixN: 'Introduce los últimos {n} dígitos del pedido',
        manualOrderEnterCodeDeliveroo: 'Introduce los 3 o 4 dígitos del código (impreso con # en el ticket)',
        manualOrderInvalidCode: 'El código no es válido',
        manualOrderCreating: 'Creando pedido...',
        manualOrderErrorTitle: 'No se ha podido crear el pedido',
    manualOrderError: 'Inténtalo de nuevo.',
        manualOrderExistsOpened: 'Ese pedido ya existía. Lo hemos abierto.',
        manualOrderExistsLooking: 'Buscando el pedido...',
        manualOrderExistsOtherPlatform: 'Ese código ya está registrado en {platform}, no en la plataforma que has elegido. Comprueba la plataforma y vuelve a escribirlo.',
        manualOrderExistsNotFoundTitle: 'Ese pedido ya existe',
        manualOrderExistsNotFoundBody: 'El código ya está registrado, pero no lo encontramos en la tablet. Pulsa Ayuda y cuéntanos qué plataforma y qué código has escrito.',
        manualOrderOwnDelivery: 'Delivery propio',
        manualOrderTakeAway: 'Recogida',
        manualOrderLoadingPlatforms: 'Cargando plataformas...',
        manualOrderNoPlatforms: 'No hay plataformas configuradas para este restaurante.',
        manualOrderLoadError: 'No se pudieron cargar las plataformas. Inténtalo de nuevo.',
        manualOrderRetry: 'Reintentar',
        // Rider check-in
        riderArrivedTitle: 'Nuevo rider',
        riderArrivedBody: 'El rider del pedido {orderId} está esperando',
        riderIsHere: 'Rider aquí',
        riderReminderTitle: 'Sigue esperando',
        riderReminderBody: 'El rider del pedido {orderId} lleva {minutes} min esperando',
        ridersWaiting: '{count} rider esperando | {count} riders esperando',
        riderOrderDeliveredTitle: 'Entregado',
        riderWaitMinutes: '{minutes} min esperando',
        riderJustArrived: 'Acaba de llegar',
        ridersPopupTitle: 'Riders',
        ridersPopupWaiting: 'Esperando',
        ridersPopupDelivered: 'Entregados',
        ridersPopupEmptyWaiting: 'No hay riders esperando',
        ridersPopupEmptyDelivered: 'Aún no se ha entregado ningún pedido',
        ridersPopupClose: 'Cerrar',
        ridersPopupDeliveredAt: 'Entregado a las {time} · hace {minutes} min',
        ridersPopupDeliveredJustNow: 'Entregado a las {time} · ahora',
        // Photo coverage alert (local kitchen nudge)
        coverageAlertStatus: 'Último pedido sin foto | Últimos {count} pedidos sin foto',
        coverageAlertTitle: '¿Retomamos las fotos?',
        coverageAlertAck: 'Sí, en el siguiente pedido',
        coverageAlertCant: 'Ahora no podemos',
        coverageAlertReasonTitle: '¿Qué está pasando?',
        coverageAlertBusy: 'Estamos a tope',
        // El compromiso lo pone el operario y sin plazo: el hint anterior ("Os avisamos en
        // 10 min") anunciaba la próxima insistencia, justo lo contrario del rediseño.
        // "Retomamos", NO "las hacemos": las fotos de esos pedidos ya no se pueden hacer
        // (han salido), lo que se retoma es el hábito. Medido: una línea con margen.
        coverageAlertBusyHint: 'Retomamos al bajar el lío',
        coverageAlertSupport: 'Algo falla en la tablet',
        coverageAlertSupportHint: 'Abrir soporte',
        coverageAlertBack: 'Volver',
        coverageAlertDismiss: 'Cerrar aviso',
        coverageSupportPrefill: 'Hola, somos el equipo de cocina de {store}. Necesitamos ayuda con las fotos de pedidos. Ahora hay {count} pedidos sin foto. ¿Podéis ayudarnos?',
        coverageThanks: 'Fotos al día. ¡Gracias!',
        // --- Guided flow modal (shared shell: help today, AI-wrong next) ---
        guidedFlowYes: 'Sí, ya está',
        guidedFlowNo: 'No, avisar a soporte',
        guidedFlowBack: 'Volver',
        guidedFlowRetry: 'Reintentar',
        guidedFlowReloadApp: 'Recargar la app',
        guidedFlowUnavailableTitle: 'Ahora no podemos abrir el chat de soporte',
        guidedFlowUnavailableOffline: 'La tablet está sin conexión. Cuando vuelva, pulsa Reintentar.',
        guidedFlowUnavailableMessenger: 'El chat no ha cargado. Prueba a recargar la app.',
        // --- Help flow: the six one-tap topics + free text (helpFlow.js) ---
        helpFlowTitle: '¿En qué te ayudamos?',
        helpFlowTopicMissingOrder: 'No me aparece un pedido',
        helpFlowTopicItemFlaggedPresent: 'Dice que falta un producto y está',
        helpFlowTopicCannotTakePhoto: 'No puedo hacer la foto',
        helpFlowTopicSeeOrderPhotos: 'Quiero ver las fotos de un pedido',
        helpFlowTopicUnexpectedOrders: 'Me aparecen pedidos que no debería',
        helpFlowTopicLeftWithoutPhoto: 'El pedido salió sin foto',
        helpFlowTopicOther: 'Otra cosa',
        helpFlowTopicVoiceNote: 'Mandar una nota de voz',
        helpFlowPickTitle: '¿Qué pedido?',
        helpFlowPickFlaggedTitle: '¿En qué pedido dice que falta algo?',
        helpFlowPickNoPhotoTitle: '¿Qué pedido salió sin foto?',
        helpFlowPickNoPhotoEmpty: 'No hay pedidos recientes sin foto.',
        helpFlowPickTypeCode: 'Escribir el código',
        helpFlowCodeTitle: '¿Qué código tiene el pedido?',
        helpFlowCodeHint: 'Lo encontrarás en el ticket o en la bolsa.',
        helpFlowCodePlaceholder: 'Código del pedido',
        helpFlowCodeSkip: 'No lo tengo',
        helpFlowMsgOrderTyped: 'Pedido {code} (escrito a mano en la tablet).',
        helpFlowPickNone: 'No está en la lista',
        helpFlowBadgeIncorrect: 'IA: falta producto',
        helpFlowBadgeCorrect: 'Correcto',
        helpFlowBadgePending: 'Con foto, sin resultado',
        helpFlowBadgeNoPhoto: 'Sin foto',
        helpFlowWorkingReload: 'Vamos a reiniciar la app…',
        helpFlowWorkingSub: 'Tarda unos segundos. Al volver te preguntamos si se ha arreglado.',
        helpFlowConfirmSub: 'Hemos recargado la app.',
        helpFlowConfirmMissingOrder: '¿Ya te aparece el pedido?',
        helpFlowConfirmCamera: '¿Ya funciona la cámara?',
        helpFlowEvidenceOrders: 'Ahora no hay ningún pedido en pantalla | Ahora hay 1 pedido en pantalla | Ahora hay {count} pedidos en pantalla',
        helpFlowEvidenceCameraOk: 'La cámara está en marcha',
        helpFlowEvidenceCameraFault: 'La cámara sigue fallando: {code}',
        helpFlowResolvedToast: '¡Resuelto! Si vuelve a pasar, avísanos.',
        helpFlowSentToast: 'Enviado a soporte. Te contestamos en el chat.',
        helpVoiceSpeakNow: 'Habla ahora. Al terminar, para la grabación y pulsa enviar.',
        helpVoiceTapMic: 'Si no se ha puesto a grabar, toca el micrófono del chat.',
        // --- Help flow: ver las fotos de un pedido (orderPhotos.js, visor en el propio modal) ---
        helpPhotosPickTitle: '¿De qué pedido quieres ver las fotos?',
        helpPhotosLoading: 'Buscando los últimos pedidos…',
        helpPhotosEmpty: 'Todavía no hay pedidos con foto.',
        helpPhotosFailed: 'No hemos podido cargar los pedidos.',
        helpPhotosMore: 'Ver pedidos anteriores',
        helpPhotosAskSupport: 'Pedírselas a soporte',
        helpPhotosCount: '1 foto | {count} fotos',
        helpPhotosBadgeNoResult: 'Sin resultado',
        orderPhotosCounter: 'Foto {index} de {count}',
        orderPhotosAlt: 'Foto {index} del pedido {code}',
        orderPhotosPrev: 'Foto anterior',
        orderPhotosNext: 'Foto siguiente',
        orderPhotosImageFailed: 'No se ha podido cargar la foto',
        orderPhotosLoadFailed: 'No hemos podido cargar las fotos de este pedido.',
        orderPhotosNone: 'Este pedido todavía no tiene fotos en el sistema.',
        orderPhotosNoneHint: 'Si acabas de hacerlas, tardan unos segundos en subir.',
        orderPhotosOtherOrders: 'Ver otros pedidos',
        orderPhotosCheckAgain: 'Volver a comprobar',
        orderPhotosLoading: 'Cargando las fotos…',
        orderPhotosOffline: 'Sin conexión',
        orderPhotosSupport: '¿Algo no cuadra? Escribir a soporte',
        orderPhotosJustNow: 'ahora mismo',
        orderPhotosMinutesAgo: 'hace {minutes} min',
        orderPhotosYesterday: 'ayer, {time}',
        orderPhotosDate: '{date}, {time}',
        // --- Login help: mensaje contextual a soporte (loginHelp.js) ---
        loginHelpIntro: 'Hola, el equipo de cocina no consigue iniciar sesión en la tablet.',
        loginHelpAttempt: 'Está intentando entrar con el dispositivo {device} y el código {otp}, pero no le deja.',
        loginHelpNoDevice: '(sin dispositivo)',
        loginHelpNoOtp: '(sin código)',
        loginHelpError: 'El error que aparece: {error}.',
        loginHelpLastLogin: 'El último acceso correcto en esta tablet fue con {device} ({restaurant}), {age}.',
        loginHelpUnknownRestaurant: 'restaurante desconocido',
        loginHelpNoHistory: 'En esta tablet no consta ningún acceso correcto anterior.',
        loginHelpJustNow: 'hace un momento',
        loginHelpMinutesAgo: 'hace {minutes} min',
        loginHelpHoursAgo: 'hace {hours} h',
        loginHelpDaysAgo: 'hace {days} días',
        loginHelpTech: 'Login · v{version}',
        loginHelpSentToast: 'Enviado a soporte. Te contestamos en el chat.',
        loginHelpUnavailable: 'No hemos podido abrir el chat. Revisa la conexión.',
        // The support message the composer opens with (composeHelpMessage)
        aiWrongTitle: '¿Qué ha pasado con ese producto? | ¿Qué ha pasado con esos productos?',
        aiWrongWasThere: 'Estaba todo, pero no lo ha detectado',
        aiWrongDifferentPackaging: 'Lo he empaquetado de forma distinta',
        aiWrongOutOfStock: 'Rotura de stock',
        aiWrongSkip: 'Cerrar',
        aiWrongBack: 'Volver',
        aiWrongSentToast: 'Gracias, se lo pasamos al equipo.',
        aiWrongMsgWasThere: 'La app dice que falta un producto, pero estaba todo en la bolsa y no lo ha detectado.',
        aiWrongMsgDifferentPackaging: 'La app dice que falta un producto, pero lo hemos empaquetado de otra forma.',
        aiWrongMsgOutOfStock: 'La app dice que falta un producto, pero ha habido rotura de stock.',
        aiWrongMsgItems: 'Productos que marcó como que faltaban: {items}.',
        helpFlowMsgIntro: 'Hola, os escribimos desde Bronze Tracker (la tablet de cocina) de {store}.',
        helpFlowMsgPlatform: 'El pedido es de {platform}.',
        helpFlowMsgOrderList: 'El pedido que no debería estar: {codes} | Los {count} pedidos que no deberían estar: {codes}',
        helpFlowPickPlatformTitle: '¿De qué agregadora es el pedido?',
        helpFlowPickPlatformNone: 'No lo sé',
        helpFlowPickOrdersTitle: '¿Cuáles no deberían estar?',
        helpFlowPickOrdersHint: 'Puedes marcar más de uno',
        helpFlowComposeTitle: '¿Qué está pasando?',
        helpFlowComposePlaceholder: 'Cuéntanoslo con tus palabras…',
        helpFlowComposeSend: 'Enviar a soporte',
        helpFlowMsgMissingOrder: 'No nos aparece un pedido en la tablet.',
        helpFlowMsgItemFlaggedPresent: 'La app dice que falta un producto, pero está en la bolsa.',
        helpFlowMsgCannotTakePhoto: 'No podemos hacer la foto.',
        helpFlowMsgSeeOrderPhotos: 'Queremos ver las fotos de un pedido.',
        helpFlowMsgSeeOrderPhotosViewed: 'Hemos revisado las fotos de este pedido y necesitamos ayuda.',
        helpFlowMsgUnexpectedOrders: 'Nos aparecen pedidos que no deberían estar.',
        helpFlowMsgLeftWithoutPhoto: 'Un pedido salió sin foto.',
        helpFlowMsgVoiceNote: 'Os lo contamos en una nota de voz.',
        helpFlowMsgOrder: 'Pedido {code}',
        helpFlowMsgAnalysis: 'análisis {id}',
        helpFlowMsgManualOrder: 'añadido a mano',
        helpFlowMsgRemedyReload: 'Ya hemos recargado la app y sigue igual.',
        helpFlowMsgTech: 'Tablet {device} · v{version}',
        helpFlowMsgConnOk: 'conexión OK',
        helpFlowMsgConnOffline: 'sin conexión',
        helpFlowMsgConnDeaf: 'conexión inestable',
        helpFlowMsgOrdersOnScreen: 'ningún pedido en pantalla | 1 pedido en pantalla | {count} pedidos en pantalla',
        helpFlowMsgWithoutPhoto: 'ninguno sin foto | 1 sin foto | {count} sin foto',
        helpFlowMsgCodes: 'En pantalla: {codes}',
        helpFlowMsgManualCount: '1 añadido a mano | {count} añadidos a mano',
        helpFlowMsgCameraFault: 'Cámara: fallo {code}',
        helpFlowMsgCameraOk: 'Cámara OK ({width}×{height})',
        helpFlowMsgCameraNoPermission: 'Cámara: sin permiso',
        helpFlowMsgCameraPermissionPending: 'Cámara: permiso sin responder',
        helpFlowMsgCameraRunning: 'Cámara en marcha',
        helpFlowMsgCameraStarting: 'Cámara: arrancando o sin imagen todavía',
        helpFlowMsgCameraCount: 'ninguna cámara detectada | 1 cámara detectada | {count} cámaras detectadas',
        helpFlowMsgCameraResolution: 'calidad {resolution}px',
        cameraCaptureMethod: 'Método de captura',
        cameraCaptureMethodHint: 'Sensor, solo si la foto corta la bandeja',
        cameraCaptureMethodImageCapture: 'Sensor (más campo, tarda más)',
        cameraCaptureMethodCanvas: 'Rápido (lo que ves en pantalla)',
        cameraCaptureMethodImageCaptureShort: 'Sensor',
        cameraCaptureMethodCanvasShort: 'Rápido',
        cameraPhotoResolution: 'Resolución de las fotos',
        cameraPhotoResolutionHint: 'Más alta: más nítida, sube más lenta',
        cameraPhotoResolutionLow: 'Baja',
        cameraPhotoResolutionMedium: 'Media',
        cameraPhotoResolutionHigh: 'Alta',
        cameraPhotoResolutionRecommended: 'recomendada',
        cameraExposureComp: 'Compensación de exposición',
        cameraExposureCompHint: 'Menos si sale quemado, más si sale oscuro',
        // Black image detection
        retryingCapture: 'Reintentando captura...',
        blackImageDetected: 'No se ha podido capturar la foto. Comprueba que la cámara no esté tapada y vuelve a intentarlo.',
        blackImageTitle: 'No se ha podido hacer la foto',
        blackImageBody: 'Comprueba que nada tapa la cámara y vuelve a intentarlo.',
        blackImageDetection: 'Detectar fotos negras',
        blackImageDetectionHint: 'Repite sola las fotos negras, hasta 2 veces',
        // Camera / analysis error popups
        uploadPhotosError: 'No se han podido subir todas las fotos. Por favor, inténtalo de nuevo.',
        analysisIdNotFound: 'No se encontró ID de análisis para la orden',
        analysisSaveError: 'Error al guardar el resultado del análisis en IndexDB',
        analysisFailedRetry: 'El pedido no se ha podido analizar. Por favor, inténtalo de nuevo pulsando el botón Analizar.',
        analysisQueuedOffline: 'Pedido {id}: sin conexión, se analizará al reconectar.',
        analysisQueuedUploading: 'Pedido {id}: subiendo fotos, se analizará al terminar.',
        continueInBackground: 'Continuar en segundo plano',
        bgAnalysisCorrect: 'Pedido {id}: correcto',
        bgAnalysisMissingDetail: 'Pedido {id}: {summary}',
        bgAnalysisIncorrect: 'Pedido {id}: faltan productos, revisar',
        missingVerb: 'falta | faltan',
        missingOthers: 'otro producto | otros {count} productos',
        and: 'y',
        tagOffline: 'Sin conexión',
        tagUploading: 'Subiendo',
        tagCorrect: 'Correcto',
        tagReview: 'Revisar',
        qrScanPartial: 'La lectura llegó cortada. Vuelve a escanear el ticket.',
        qrScanDeliveredTitle: 'Entregado al rider',
        qrScanAlreadyTag: 'Ya entregado',
        qrScanAlreadyBody: 'Este pedido ya estaba cerrado',
        qrScanNotHere: 'Ese ticket no es de esta tienda. No se ha cerrado ningún pedido.',
        qrScanOffline: 'Sin conexión: no se ha podido comprobar el pedido. Vuelve a escanear el ticket.',
        qrScanNotSavedTag: 'Sin guardar',
        qrScanNotSavedBody: 'La entrega no ha llegado al servidor. Se reintentará al volver la conexión, o vuelve a escanear.',
        qrScanUnknown: 'La pistola ha leído un código que no es de pedido: {text}',
        qrGunTutorialGroup: 'Pistola lectora',
        qrGunTutorialSettings: 'Cómo conectar y usar la pistola',
        qrGunTutorialSettingsHint: 'Emparejarla y cerrar pedidos escaneando',
        qrGunTutorialTitle: 'Pistola lectora',
        qrGunTutorialExit: 'Salir',
        qrGunTutorialStepOf: 'Paso {step} de {total}',
        qrGunTutorialNext: 'Siguiente',
        qrGunTutorialBack: 'Atrás',
        qrGunTutorialReplay: 'Ver otra vez',
        qrGunTutorialPowerTitle: 'Enciende la pistola',
        qrGunTutorialPowerBody: 'Pulsa el gatillo.',
        qrGunTutorialPowerStrong: 'Así la tablet la puede encontrar.',
        qrGunTutorialPairTitle: 'Conéctala a la tablet',
        qrGunTutorialPairBody: 'Abre los Ajustes de la tablet → Bluetooth y toca la que empieza por «Hyper 160S».',
        qrGunTutorialPairNote: 'Sale con un icono de teclado. Cuando ponga «Conectado», ya está.',
        qrGunTutorialBtTitle: 'Bluetooth',
        qrGunTutorialBtVisible: 'Actualmente visible para dispositivos cercanos.',
        qrGunTutorialBtPaired: 'Dispositivos enlazados',
        qrGunTutorialBtAvailable: 'Dispositivos disponibles',
        qrGunTutorialBtConnected: 'Conectado',
        qrGunTutorialPairNotFound: 'No aparece',
        qrGunTutorialNotfoundTitle: 'Si no aparece',
        qrGunTutorialNotfoundBody: 'Pulsa el gatillo para encender la pistola y espera unos segundos.',
        qrGunTutorialNotfoundNote: 'Luego vuelve a mirar la lista de Bluetooth.',
        qrGunTutorialNotfoundRetry: 'Volver a buscar',
        qrGunTutorialBackTitle: 'Vuelve a Bronze',
        qrGunTutorialBackBody: 'Abre Bronze Tracker otra vez. Funciona como siempre.',
        qrGunTutorialBackNote: 'Ahora el teclado es la pistola. Si necesitas escribir, toca el icono que sale a la izquierda de la pantalla para sacar el teclado.',
        qrGunTutorialScanTitle: 'Escanea la bolsa',
        qrGunTutorialScanBody: 'Cuando termines un pedido, apunta la pistola al QR del ticket de la bolsa y pulsa el gatillo.',
        qrGunTutorialScanStrong: 'Así el pedido queda entregado al rider.',
        qrGunTutorialNotifyTitle: 'La tablet te avisa',
        qrGunTutorialNotifyBody: 'Suena y sale «Entregado al rider» con el número del pedido.',
        qrGunTutorialNotifyNote: 'La pistola también pita al leer: ese pitido solo dice que ha leído.',
        qrGunTutorialNotifyListen: 'Escuchar el sonido',
        qrGunTutorialSleepTitle: 'Si se duerme, despiértala',
        qrGunTutorialSleepBody: 'Tras unos 10 minutos sin usarla, la pistola se apaga sola.',
        qrGunTutorialSleepStrong: 'Pulsa el gatillo: en un segundo se vuelve a conectar y suena. No está rota.',
        qrGunTutorialTestTitle: 'Pruébala',
        qrGunTutorialTestBody: 'Apunta la pistola a este código y pulsa el gatillo.',
        qrGunTutorialTestNote: 'Sube el brillo de la tablet al máximo: con poco brillo la pistola no lee la pantalla. No se cierra ningún pedido.',
        qrGunTutorialTestSkip: 'Continuar igualmente',
        qrGunTutorialTestWaiting: 'Esperando la pistola…',
        qrGunTutorialTestSuccess: '¡Funciona! La pistola está conectada.',
        qrGunTutorialTestOther: 'Eso no es un código de Bronze. Escanea el de la pantalla.',
        qrGunTutorialTestPartial: 'La lectura llegó cortada. Vuelve a escanear.',
        qrGunTutorialDoneTitle: 'Listo',
        qrGunTutorialDoneBody: 'La pistola está lista para cerrar pedidos.',
        qrGunTutorialDoneFinish: 'Terminar',
        orderStateCorrect: 'Correcto',
        orderStateWrong: 'Incorrecto',
        orderStateQueued: 'En cola',
        orderPhotoCount: '{count} foto | {count} fotos',
        takePhoto: 'Hacer la foto',
        bodyQueuedOffline: 'Se analizará al reconectar',
        bodyQueuedUploading: 'Se analizará al terminar',
        reviewGeneric: 'Faltan productos',
        // Changelog modal — content comes localised from the feed; these are the chrome.
        changelogTitle: 'Novedades',
        changelogAck: 'Entendido',
        changelogSeeAll: 'Ver todas las novedades',
        changelogSettingsHint: 'Lo nuevo de cada versión',
        // The design system's catalog (Settings → Debug), docs/sistema-diseno/README.md.
        uiCatalogOpen: 'Sistema de diseño',
        uiCatalogTitle: 'Sistema de diseño',
        uiCatalogIntro: 'Los colores, la tipografía y los componentes de la app, tal y como se ven en esta tablet.',
        uiCatalogFont: 'Tipografía',
        uiCatalogFontHint: 'Comparación: cambia la letra hasta recargar. Las que no son DM Sans necesitan conexión.',
        uiCatalogFontSystem: 'La del sistema',
        uiCatalogFontBrand: 'DM Sans (la elegida)',
        uiCatalogPalette: 'Paleta de color',
        uiCatalogPaletteHint: 'Comparación: cambia los colores hasta recargar.',
        uiCatalogPaletteBronze: 'Bronze (aprobada)',
        uiCatalogPaletteCurrent: 'La de antes',
        uiCatalogRamps: 'Paleta Bronze',
        uiCatalogRampsHint: 'Cada color en sus pasos, del 1 (el más oscuro) al 12. El 9 es el relleno: en el azul y en el amarillo es el color de marca exacto (con borde), y el resto sale calculado de él.',
        uiCatalogRampNames: {
            grey: 'Gris · fondos, tarjetas y texto',
            blue: 'Azul · acción y pedido por fotografiar',
            bronze: 'Amarillo Bronze · marca',
            green: 'Verde · correcto',
            orange: 'Naranja bronce · incorrecto',
            amber: 'Ámbar · aviso y retraso',
            red: 'Rojo · rider y cerrar sesión',
            slate: 'Pizarra · en cola',
        },
        uiCatalogBrand: 'El amarillo de marca, junto a los estados',
        uiCatalogBrandHint: 'Solo como relleno, en las superficies de la marca (arranque, login, novedades) y nunca junto al semáforo. Aquí, al lado de «revisar» y del retraso, para ver que no se confunden.',
        uiCatalogVision: 'Ver como',
        uiCatalogVisionHint: 'Simula cómo ve los colores parte de la cocina, hasta salir de esta pantalla. Las listas que se abren no se simulan.',
        uiCatalogVisionNames: {
            normal: 'Visión normal',
            deuteranopia: 'Deuteranopía (verde)',
            protanopia: 'Protanopía (rojo)',
            tritanopia: 'Tritanopía (azul)',
            achromatopsia: 'Sin color',
            glare: 'Con reflejo de cocina',
        },
        uiCatalogTrafficLight: 'Semáforo de pedidos',
        uiCatalogTrafficLightHint: 'Cómo se verían las tarjetas de la lista de pedidos: cada estado con su color, su icono y su palabra. Con «Ver como» se leen con daltonismo o con reflejo.',
        uiCatalogStateTodo: 'Por fotografiar',
        uiCatalogStatePending: 'En cola',
        uiCatalogColors: 'Color',
        uiCatalogType: 'Tipografía',
        uiCatalogTypeSample: 'Pedido listo para entregar',
        uiCatalogButtons: 'Botones',
        uiCatalogPrimary: 'Acción principal',
        uiCatalogSecondary: 'Otra acción',
        uiCatalogText: 'Enlace',
        uiCatalogOutlined: 'Contorno',
        uiCatalogWithIcon: 'Con icono',
        uiCatalogIcons: 'Iconos',
        uiCatalogLists: 'Listas y controles',
        uiCatalogGroup: 'Un grupo',
        uiCatalogDialog: 'Diálogo',
        uiCatalogOpenDialog: 'Abrir un diálogo de ejemplo',
        uiCatalogDialogEyebrow: 'Ejemplo',
        uiCatalogDialogTitle: 'Un diálogo del sistema',
        uiCatalogDialogSubtitle: 'Título, subtítulo y su X',
        uiCatalogDialogBody: 'El cuerpo se desplaza si no cabe, y las acciones van abajo, a 72 px.',
        uiCatalogToasts: 'Avisos',
        uiCatalogChips: 'Estados',
        uiCatalogTiles: 'Baldosas',
        uiCatalogChipsHint: 'Dos formas de la misma etiqueta. Elige por cómo se va a leer: de un vistazo, o en una pantalla donde el texto ya dice el estado.',
        uiCatalogChipsContainer: 'En contenedor',
        uiCatalogChipsContainerHint: 'Para una pantalla deliberada, donde el texto dice el estado. Con reflejo, un contenedor oscuro pierde su color: nunca va solo para algo urgente.',
        uiCatalogChipsSolid: 'Sólidas',
        uiCatalogChipsSolidHint: 'Para leerlo de un vistazo o algo urgente: una insignia sobre una tarjeta, un retraso.',
        uiCatalogTilesHint: 'Un botón grande que es una tarjeta: el icono en el azul de acción y sus palabras. La elegida, en el azul de selección y con su borde.',
        uiCatalogTileStacked: 'Apilada: para una rejilla de opciones',
        uiCatalogTileRow: 'En fila: el icono junto a las palabras',
        uiCatalogTileFar: 'En fila, para leer a un metro',
        uiCatalogEmpty: 'Vacío y sin conexión',
        uiCatalogEmptyHint: 'Lo que dice una lista cuando no tiene nada que enseñar o no llega a ello: un icono quieto, lo que pasa y, si lo hay, qué hacer.',
        uiCatalogEmptyTitle: 'No hay nada que mostrar',
        uiCatalogEmptyText: 'Cuando haya algo, aparecerá aquí.',
        uiCatalogOfflineTitle: 'Sin conexión',
        uiCatalogOfflineText: 'La tablet no llega a internet. Cuando vuelva, pulsa Reintentar.',
        uiCatalogSpinner: 'Cargando',
        uiCatalogSpinnerHint: 'Progreso sin medida: el icono gira mientras la app lo sigue intentando y las palabras dicen qué. Con «quitar animaciones» se queda quieto.',
        uiCatalogLoading: 'Cargando…',
        uiCatalogSampleNotification: 'Probar la notificación',
        uiCatalogSampleTitle: 'Mensaje de prueba',
        uiCatalogSampleBody: 'Así se ve un mensaje que Bronze manda a la tablet. Este es de prueba: no se envía ninguna respuesta.',
        uiCatalogSampleYes: 'Sí',
        uiCatalogSampleNo: 'No',
        settingsAdvanced: 'Avanzado',
        debugHint: 'Pruebas de cámara para soporte',
        debugLane: 'Pantalla de servicio',
        debugLaneHint: 'Se aplica al recargar la app',
        demoMode: 'Modo demo',
        demoModeHint: '3 pedidos simulados; no se envía nada',
        demoActive: 'Activo: {category} · no se envía nada',
        demoRestart: 'Reiniciar demo',
        demoRestartHint: 'Pedidos desde cero, del mismo tipo u otro',
        demoPickerTitle: '¿Qué tipo de restaurante?',
        demoPickerHint: 'Cargamos 3 pedidos simulados de ese tipo. No se envía nada.',
        demoCategoryPizza: 'Pizzas',
        demoCategoryBurger: 'Hamburguesas',
        demoCategoryChicken: 'Pollo frito',
        demoCategorySushi: 'Sushi',
        debugLaneStore: 'Según la tienda',
        debugLaneSystem: 'La nueva',
        debugLaneCurrent: 'La de ahora',
        queueEmpty: 'Todo subido',
        queueEmptyHint: 'No hay fotos esperando para subirse.',
        changelogTagNew: 'Nuevo',
        changelogTagImproved: 'Mejora',
        changelogTagIntegration: 'Integración',
        changelogTagFixed: 'Corregido'
      },
      // PrimeVue's own strings: only the ones the components adopted in docs/migracion-ui/
      // mapa-componentes.md read (Dialog, Message: aria.close · Select: the six messages).
      // src/ui/install.js reads them RAW, never through t(): PrimeVue fills {0} itself.
      primevue: {
        aria: {
          close: 'Cerrar'
        },
        emptyMessage: 'No hay opciones disponibles',
        emptyFilterMessage: 'No hay resultados',
        emptySearchMessage: 'No hay resultados',
        emptySelectionMessage: 'Nada seleccionado',
        searchMessage: '{0} resultados disponibles',
        selectionMessage: '{0} seleccionados'
      }
    },
    en: {
      message: {
        settings: 'Settings',
        deviceId: 'Device',
        restaurant: 'Restaurant',
        cameraPermission: 'Camera Permission',
        flipVertically: 'Periscope Mode\u2122',
        flipVerticallyHint: 'Turns the mirror stand’s image upright',
        periscopeTutorialTitle: 'Place the periscope',
        periscopeTutorialExit: 'Exit',
        periscopeTutorialStepOf: 'Step {step} of {total}',
        periscopeTutorialBack: 'Back',
        periscopeTutorialReplay: 'Watch again',
        periscopeTutorialSettings: 'How to place the Periscope\u2122',
        periscopeTutorialSettingsHint: 'Step-by-step guide with your camera',
        photoVideoTutorialSettings: 'How to take good photos',
        photoVideoTutorialSettingsHint: 'Video · {duration}',
        photoVideoTutorialTitle: 'How to take good photos',
        photoVideoTutorialClose: 'Close',
        photoVideoTutorialRemaining: '{time} left',
        photoVideoTutorialLoading: 'Loading the video…',
        photoVideoTutorialPause: 'Pause',
        photoVideoTutorialPlay: 'Play',
        photoVideoTutorialReplay: 'Watch again',
        photoVideoTutorialRestart: 'From the start',
        photoVideoTutorialErrorTitle: 'The video could not load',
        photoVideoTutorialErrorBody: 'Check the internet connection and try again.',
        photoVideoTutorialRetry: 'Try again',
        periscopeTutorialWelcomeTitle: 'Let’s place the periscope',
        periscopeTutorialWelcomeBody: 'It is the mirror that sticks to the corner of the tablet, above the camera. It will take a few minutes.',
        periscopeTutorialWelcomeNote: 'It only shows up the first time on this tablet. You can also find it in Settings.',
        periscopeTutorialWelcomeStart: 'Start',
        periscopeTutorialWelcomeAlready: 'It is already in place',
        periscopeTutorialNeedsTitle: 'Before you start, find these',
        periscopeTutorialNeedsBody: 'Only the periscope comes in the box. You provide the rest.',
        periscopeTutorialNeedsPeriscope: 'The periscope',
        periscopeTutorialNeedsAlcohol: 'Alcohol or degreaser',
        periscopeTutorialNeedsCloth: 'A cloth',
        periscopeTutorialNeedsPencil: 'A pencil or marker',
        periscopeTutorialNeedsNext: 'I have them',
        periscopeTutorialCleanTitle: 'Clean the camera corner',
        periscopeTutorialCleanBody: 'Put alcohol on the cloth and clean well the area where it will be stuck: the edge of the tablet next to the camera.',
        periscopeTutorialCleanStrong: 'If any grease is left, it will not stick.',
        periscopeTutorialCleanNext: 'It is clean',
        periscopeTutorialPlaceTitle: 'Put it in the corner, without sticking it',
        periscopeTutorialPlaceBody: 'The base on the edge and the mirror above the camera.',
        periscopeTutorialPlaceStrong: 'Do not remove the red plastic yet.',
        periscopeTutorialPlaceInset: 'The camera looks at the mirror and the mirror looks at the table.',
        periscopeTutorialPlaceCamera: 'Camera',
        periscopeTutorialPlaceMirror: 'Mirror',
        periscopeTutorialPlaceTable: 'Table',
        periscopeTutorialPlaceNext: 'Next',
        periscopeTutorialAlignTitle: 'Move it until you only see the table',
        periscopeTutorialAlignBody: 'Point the mirror at the table and move the periscope little by little.',
        periscopeTutorialAlignStrong: 'Nothing should mix in, neither at the top nor at the bottom.',
        periscopeTutorialAlignNext: 'It looks good',
        periscopeTutorialLiveBadge: 'Real photo · updates by itself',
        periscopeTutorialLiveAlt: 'Real photo from the camera',
        periscopeTutorialLiveStarting: 'Opening the camera…',
        periscopeTutorialLiveError: 'The camera cannot be opened.',
        periscopeTutorialLiveRetry: 'Try again',
        periscopeTutorialExampleGood: 'Good: only the table',
        periscopeTutorialExampleBadBottom: 'Bad: it mixes in at the bottom',
        periscopeTutorialExampleBadTop: 'Bad: it mixes in at the top',
        periscopeTutorialMarkTitle: 'Mark where it goes',
        periscopeTutorialMarkBody: 'Without moving it, draw around the base with the pencil: both sides and the back.',
        periscopeTutorialMarkNext: 'It is marked',
        periscopeTutorialStickTitle: 'Remove the red plastic and stick it',
        periscopeTutorialStickBody: 'Put it right on the mark.',
        periscopeTutorialStickStrong: 'Press hard for a few seconds.',
        periscopeTutorialStickNext: 'It is stuck',
        periscopeTutorialCheckTitle: 'Check that it looks right',
        periscopeTutorialCheckBody: 'Do you only see the table, with no strips of something else at the top or bottom?',
        periscopeTutorialCheckYes: 'Yes, it looks good',
        periscopeTutorialCheckNo: 'No, it needs moving',
        periscopeTutorialUnstickTitle: 'Unstick it by turning it',
        periscopeTutorialUnstickBody: 'Turn the periscope on itself, one full turn, until it comes loose.',
        periscopeTutorialUnstickNext: 'It is unstuck',
        periscopeTutorialRestickTitle: 'Stick it on the mark again',
        periscopeTutorialRestickBody: 'Put it right on the mark.',
        periscopeTutorialRestickBad: 'It does not stick well',
        periscopeTutorialRetapeTitle: 'Change the tape',
        periscopeTutorialRetapeBody: 'Buy double-sided adhesive tape. Take the old tape off the base and stick a new piece of the same size.',
        periscopeTutorialRetapeNext: 'It has new tape',
        periscopeTutorialDoneTitle: 'Periscope in place!',
        periscopeTutorialDoneBody: 'We turned on Periscope Mode\u2122 so the image comes out the right way up.',
        periscopeTutorialDoneBody2: 'You can now put the tablet on its stand.',
        periscopeTutorialDoneFinish: 'Finish',
        immersiveViewport: 'Immersive camera mode',
        immersiveViewportHint: 'Full-screen camera',
        immersiveViewportModalTitle: 'Immersive camera mode enabled',
        immersiveViewportModalBody: 'The camera now looks bigger and buttons will appear on top of the image. If you prefer the previous layout, disable this option in Settings.',
        immersiveViewportModalButton: 'Got it',
        signOut: 'Sign Out',
        signOutHint: 'You’ll need the code to come back',
        general: 'General',
        camera: 'Camera',
        cameraHint: 'Automatic uses the back one',
        signIn: 'Sign In',
        signingIn: 'Signing in...',
        queue: 'Upload Queue',
        photo: 'Photo',
        analyze: 'Analyze',
        photoAndAnalyze: 'Photo & analyze',
        retakeReminder: 'Remember to come back, take the photo and analyze',
        retakeReminderTitle: 'Order {code} not fixed yet',
        retakeReminderBody: 'Open it again, take the photo and tap Analyze.',
        retakeAimTitle: 'Photograph:',
        retakeAimFoot: 'then press Analyze to continue',
        avoidDuplicatePhotos: 'Remember not to repeat the same photo',
        imagesLeftToUpload: 'Images left to upload',
        cancelAnalysis: 'Cancel Analysis',
        back: 'Back',
        timeout: 'The order content could not be analyzed.',
        accept: 'Accept',
        analyzing: 'Analyzing order',
        analysisError: 'Error analyzing order',
        close: 'Close',
        checkOrder: 'Check order',
        missingItems: 'Missing items',
        notDetected: '{count} product missing | {count} products missing',
        notDetectedSubtitleSingle: 'Check the order before closing the bag',
        missingCount: '{count} missing | {count} missing',
        stillContinue: 'Deliver without fixing',
        stillContinueWarning: 'The customer may complain',
        addPhotos: 'Fix and take another photo',
        itemNotDetectedInPhoto: 'One of these products was not detected | {count} of these products were not detected',
        perfect: 'Everything is perfect!',
        finalize: 'Finalize',
        help: 'Help',
        helpPrefill: 'Hi, this is the kitchen team at {store}. We need help with: ',
        noOrders: 'We don\'t have any orders yet',
        resolution: 'Resolution',
        cameraDefault: 'Automatic',
        uploadQueue: 'Upload queue',
        debug: 'Debug',
        version: 'Version',
        madeWithLove: 'Made with ❤️ in Spain',
        confirmSignOut: 'Are you sure you want to sign out?',
        reload: 'Reload',
        clearCache: 'Clear cache',
        sessionExpired: 'Session expired, redirecting to login',
        newServiceWorker: 'New service worker detected. Preparing to update...',
        errorLoadingSettings: 'Error loading settings',
        indexedDBCleared: 'IndexedDB tables cleared successfully',
        errorClearingIndexedDB: 'Error clearing IndexedDB',
        loading: 'Loading...',
        startupConnecting: 'Connecting to your restaurant…',
        loadingTakingLong: 'This is taking longer than usual',
        retryingAutomatically: 'We’re still retrying automatically. You don’t need to do anything.',
        startupAutoReloadIn: 'The app will restart on its own in {s} s',
        startupRestarting: 'Restarting the app…',
        startupFailedTitle: 'No connection',
        startupFailedBody: 'We’ve stopped retrying. Check the restaurant Wi-Fi and tap Retry. If it keeps failing, tell your manager.',
        startupDeviceMeta: 'Device: {id} · v{version}',
        retryStartup: 'Retry',
        deviceIdChanged: 'This device’s id has changed. Enter the new device id and its code to sign in again.',
        otpCode: 'OTP Code',
        needHelp: 'Need help?',
        loginSuccessful: 'Login successful!',
        sessionExpiredRelogin: 'Your session has expired. Please sign in again.',
        errorOccurred: 'An error occurred. Please try again.',
        incorrectCredentials: 'Couldn’t sign in. Check the device and the OTP code.',
        userNotFound: 'Error during sign in: User not found.',
        invalidOTP: 'Error during sign in: Invalid OTP.',
        hideTicket: 'Hide',
        showTicket: 'Ticket',
        listView: 'List',
        groupView: 'Group',
        allergiesLabel: 'ALLERGIES',
        commentsLabel: 'COMMENTS',
        contentNotAvailable: 'Content not available',
        uploadTakingTooLong: 'Upload is taking a little longer…',
        analysisTakingTooLong: 'The analysis is taking longer than expected\nPlease check your internet connection',
        unknown: 'Unknown',
        unknownOrder: 'Unknown order',
        messageFrom: 'Message from',
        secondsRemaining: 'seconds remaining',
        justNow: 'Just now',
        minuteAgo: '1 min ago',
        minutesAgo: '{minutes} mins ago',
        // Camera preview literals
        initializingCamera: 'Initializing camera...',
        startCamera: 'Start camera',
        cameraFaultPermissionTitle: 'Camera permission missing',
        cameraFaultPermissionBlockedBody: 'The browser has the camera blocked for Bronze. Tap the padlock next to the address, set Camera to "Allow", and try again.',
        cameraFaultPermissionPendingBody: 'The browser asked for permission to use the camera and nobody answered. Tap "Allow" on the prompt at the top.',
        cameraFaultBusyAppTitle: 'The camera is busy',
        cameraFaultBusyAppBody: 'Another app on the tablet is using the camera. Close it from recent apps and try again. If it persists, restart the tablet.',
        cameraFaultOtherWindowTitle: 'Bronze is open twice',
        cameraFaultOtherWindowBody: 'Bronze Tracker is open in another window or tab, and only one can use the camera. Close the other one and try again.',
        cameraFaultNeedsTapTitle: 'Tap to turn the camera on',
        cameraFaultNeedsTapBody: 'The browser needs you to tap the screen before it will start the camera. Tap the button below.',
        cameraFaultNoCameraTitle: 'No camera detected',
        cameraFaultNoCameraBody: 'This tablet exposes no camera. Check that it is not disabled in the device settings.',
        cameraFaultUnknownTitle: 'Could not start the camera',
        cameraFaultUnknownBody: 'Try again. If it will not start, restart the tablet and tell support the code below.',
        cameraRetryAttempt: 'Retrying… ({attempt}/{total})',
        cancel: 'Cancel',
        more: 'more',
        photoDiscarded: 'Photo discarded',
        capturing: 'Capturing...',
        // Manual order
        manualOrderAdd: 'Add order',
        manualOrderAddFull: 'Add order manually',
        manualOrderTitle: 'Manual order',
        manualOrderSelectPlatform: 'Which platform is the order from?',
        manualOrderEnterCode: 'Enter the order code',
        manualOrderEnterCodeN: 'Enter the {n}-digit order code',
        manualOrderEnterCodeCharsN: 'Enter the {n}-character order code',
        manualOrderEnterOrderSuffixN: 'Enter the last {n} digits of the order',
        manualOrderEnterCodeDeliveroo: 'Enter the 3 or 4-digit code (printed with # on the ticket)',
        manualOrderInvalidCode: 'Invalid code',
        manualOrderCreating: 'Creating order...',
        manualOrderErrorTitle: 'Could not create the order',
    manualOrderError: 'Please try again.',
        manualOrderExistsOpened: 'That order already existed. We opened it.',
        manualOrderExistsLooking: 'Looking for the order...',
        manualOrderExistsOtherPlatform: 'That code is already registered under {platform}, not the platform you picked. Check the platform and enter it again.',
        manualOrderExistsNotFoundTitle: 'That order already exists',
        manualOrderExistsNotFoundBody: 'The code is already registered, but we could not find it on the tablet. Tap Help and tell us which platform and code you entered.',
        manualOrderOwnDelivery: 'Own delivery',
        manualOrderTakeAway: 'Take away',
        manualOrderLoadingPlatforms: 'Loading platforms...',
        manualOrderNoPlatforms: 'No platforms configured for this restaurant.',
        manualOrderLoadError: 'Could not load the platforms. Please try again.',
        manualOrderRetry: 'Retry',
        // Rider check-in
        riderArrivedTitle: 'New rider',
        riderArrivedBody: 'Rider for order {orderId} is waiting',
        riderIsHere: 'Rider here',
        riderReminderTitle: 'Still waiting',
        riderReminderBody: 'Rider for order {orderId} has been waiting {minutes} min',
        ridersWaiting: '{count} rider waiting | {count} riders waiting',
        riderOrderDeliveredTitle: 'Delivered',
        riderWaitMinutes: '{minutes} min waiting',
        riderJustArrived: 'Just arrived',
        ridersPopupTitle: 'Riders',
        ridersPopupWaiting: 'Waiting',
        ridersPopupDelivered: 'Delivered',
        ridersPopupEmptyWaiting: 'No riders waiting',
        ridersPopupEmptyDelivered: 'No orders delivered yet',
        ridersPopupClose: 'Close',
        ridersPopupDeliveredAt: 'Delivered at {time} · {minutes} min ago',
        ridersPopupDeliveredJustNow: 'Delivered at {time} · just now',
        // Photo coverage alert (local kitchen nudge)
        coverageAlertStatus: 'Last order without a photo | Last {count} orders without a photo',
        coverageAlertTitle: 'Ready to take photos again?',
        coverageAlertAck: 'Yes, with the next order',
        coverageAlertCant: 'We can’t right now',
        coverageAlertReasonTitle: 'What’s going on?',
        coverageAlertBusy: 'We’re slammed',
        coverageAlertBusyHint: 'Back on it after the rush',
        coverageAlertSupport: 'Something’s wrong with the tablet',
        coverageAlertSupportHint: 'Open support',
        coverageAlertBack: 'Back',
        coverageAlertDismiss: 'Dismiss alert',
        coverageSupportPrefill: 'Hi, this is the kitchen team at {store}. We need help taking order photos. There are currently {count} orders without a photo. Can you help us?',
        coverageThanks: 'Photos back on track. Thanks!',
        // --- Guided flow modal (shared shell: help today, AI-wrong next) ---
        guidedFlowYes: 'Yes, all good',
        guidedFlowNo: 'No, tell support',
        guidedFlowBack: 'Back',
        guidedFlowRetry: 'Retry',
        guidedFlowReloadApp: 'Reload the app',
        guidedFlowUnavailableTitle: 'We can’t open the support chat right now',
        guidedFlowUnavailableOffline: 'The tablet is offline. When it is back, tap Retry.',
        guidedFlowUnavailableMessenger: 'The chat did not load. Try reloading the app.',
        // --- Help flow: the six one-tap topics + free text (helpFlow.js) ---
        helpFlowTitle: 'What do you need help with?',
        helpFlowTopicMissingOrder: 'An order is missing from the screen',
        helpFlowTopicItemFlaggedPresent: 'It says an item is missing but it is there',
        helpFlowTopicCannotTakePhoto: 'I cannot take the photo',
        helpFlowTopicSeeOrderPhotos: 'I want to see an order’s photos',
        helpFlowTopicUnexpectedOrders: 'Orders I should not see are showing up',
        helpFlowTopicLeftWithoutPhoto: 'The order left without a photo',
        helpFlowTopicOther: 'Something else',
        helpFlowTopicVoiceNote: 'Send a voice note',
        helpFlowPickTitle: 'Which order?',
        helpFlowPickFlaggedTitle: 'Which order does it say is missing something?',
        helpFlowPickNoPhotoTitle: 'Which order left without a photo?',
        helpFlowPickNoPhotoEmpty: 'There are no recent orders without a photo.',
        helpFlowPickTypeCode: 'Type the code',
        helpFlowCodeTitle: 'What is the order’s code?',
        helpFlowCodeHint: 'You will find it on the ticket or on the bag.',
        helpFlowCodePlaceholder: 'Order code',
        helpFlowCodeSkip: 'I do not have it',
        helpFlowMsgOrderTyped: 'Order {code} (typed by hand on the tablet).',
        helpFlowPickNone: 'It is not in the list',
        helpFlowBadgeIncorrect: 'AI: item missing',
        helpFlowBadgeCorrect: 'Correct',
        helpFlowBadgePending: 'Photo taken, no result yet',
        helpFlowBadgeNoPhoto: 'No photo',
        helpFlowWorkingReload: 'We are going to restart the app…',
        helpFlowWorkingSub: 'It takes a few seconds. When it is back, we will ask whether that fixed it.',
        helpFlowConfirmSub: 'We reloaded the app.',
        helpFlowConfirmMissingOrder: 'Is the order showing now?',
        helpFlowConfirmCamera: 'Is the camera working now?',
        helpFlowEvidenceOrders: 'No orders on screen right now | 1 order on screen right now | {count} orders on screen right now',
        helpFlowEvidenceCameraOk: 'The camera is running',
        helpFlowEvidenceCameraFault: 'The camera is still failing: {code}',
        helpFlowResolvedToast: 'Sorted! If it happens again, let us know.',
        helpFlowSentToast: 'Sent to support. We will reply in the chat.',
        helpVoiceSpeakNow: 'Speak now. When you finish, stop the recording and press send.',
        helpVoiceTapMic: 'If it is not recording, tap the microphone in the chat.',
        // --- Help flow: see an order's photos (orderPhotos.js, viewer inside the modal) ---
        helpPhotosPickTitle: 'Which order’s photos do you want to see?',
        helpPhotosLoading: 'Looking for the latest orders…',
        helpPhotosEmpty: 'There are no orders with photos yet.',
        helpPhotosFailed: 'We could not load the orders.',
        helpPhotosMore: 'Show older orders',
        helpPhotosAskSupport: 'Ask support for them',
        helpPhotosCount: '1 photo | {count} photos',
        helpPhotosBadgeNoResult: 'No result',
        orderPhotosCounter: 'Photo {index} of {count}',
        orderPhotosAlt: 'Photo {index} of order {code}',
        orderPhotosPrev: 'Previous photo',
        orderPhotosNext: 'Next photo',
        orderPhotosImageFailed: 'The photo could not be loaded',
        orderPhotosLoadFailed: 'We could not load this order’s photos.',
        orderPhotosNone: 'This order has no photos in the system yet.',
        orderPhotosNoneHint: 'If you just took them, they take a few seconds to upload.',
        orderPhotosOtherOrders: 'See other orders',
        orderPhotosCheckAgain: 'Check again',
        orderPhotosLoading: 'Loading the photos…',
        orderPhotosOffline: 'No connection',
        orderPhotosSupport: 'Something wrong? Write to support',
        orderPhotosJustNow: 'just now',
        orderPhotosMinutesAgo: '{minutes} min ago',
        orderPhotosYesterday: 'yesterday, {time}',
        orderPhotosDate: '{date}, {time}',
        // --- Login help: contextual message to support (loginHelp.js) ---
        loginHelpIntro: 'Hi, the kitchen team cannot log in on the tablet.',
        loginHelpAttempt: 'They are trying to sign in with device {device} and code {otp}, but it will not let them.',
        loginHelpNoDevice: '(no device)',
        loginHelpNoOtp: '(no code)',
        loginHelpError: 'The error shown: {error}.',
        loginHelpLastLogin: 'The last successful login on this tablet was with {device} ({restaurant}), {age}.',
        loginHelpUnknownRestaurant: 'unknown restaurant',
        loginHelpNoHistory: 'No previous successful login is on record on this tablet.',
        loginHelpJustNow: 'just now',
        loginHelpMinutesAgo: '{minutes} min ago',
        loginHelpHoursAgo: '{hours} h ago',
        loginHelpDaysAgo: '{days} days ago',
        loginHelpTech: 'Login · v{version}',
        loginHelpSentToast: 'Sent to support. We will reply in the chat.',
        loginHelpUnavailable: 'We could not open the chat. Check the connection.',
        // The support message the composer opens with (composeHelpMessage)
        aiWrongTitle: 'What happened with that item? | What happened with those items?',
        aiWrongWasThere: 'It was all there, it just did not detect it',
        aiWrongDifferentPackaging: 'I packed it differently',
        aiWrongOutOfStock: 'Out of stock',
        aiWrongSkip: 'Close',
        aiWrongBack: 'Back',
        aiWrongSentToast: 'Thanks, we are passing it to the team.',
        aiWrongMsgWasThere: 'The app says an item is missing, but it was all in the bag and it did not detect it.',
        aiWrongMsgDifferentPackaging: 'The app says an item is missing, but we packed it differently.',
        aiWrongMsgOutOfStock: 'The app says an item is missing, but we ran out of stock.',
        aiWrongMsgItems: 'Items it flagged as missing: {items}.',
        helpFlowMsgIntro: 'Hi, we are writing from Bronze Tracker (the kitchen tablet) at {store}.',
        helpFlowMsgPlatform: 'The order is from {platform}.',
        helpFlowMsgOrderList: 'The order that should not be there: {codes} | The {count} orders that should not be there: {codes}',
        helpFlowPickPlatformTitle: 'Which aggregator is the order from?',
        helpFlowPickPlatformNone: 'I do not know',
        helpFlowPickOrdersTitle: 'Which ones should not be there?',
        helpFlowPickOrdersHint: 'You can tick more than one',
        helpFlowComposeTitle: 'What is going on?',
        helpFlowComposePlaceholder: 'Tell us in your own words…',
        helpFlowComposeSend: 'Send to support',
        helpFlowMsgMissingOrder: 'An order is not showing on the tablet.',
        helpFlowMsgItemFlaggedPresent: 'The app says an item is missing, but it is in the bag.',
        helpFlowMsgCannotTakePhoto: 'We cannot take the photo.',
        helpFlowMsgSeeOrderPhotos: 'We want to see the photos of an order.',
        helpFlowMsgSeeOrderPhotosViewed: 'We checked the photos of this order and need help.',
        helpFlowMsgUnexpectedOrders: 'Orders that should not be there are showing up.',
        helpFlowMsgLeftWithoutPhoto: 'An order left without a photo.',
        helpFlowMsgVoiceNote: 'We are telling you in a voice note.',
        helpFlowMsgOrder: 'Order {code}',
        helpFlowMsgAnalysis: 'analysis {id}',
        helpFlowMsgManualOrder: 'added by hand',
        helpFlowMsgRemedyReload: 'We already reloaded the app and it is still the same.',
        helpFlowMsgTech: 'Tablet {device} · v{version}',
        helpFlowMsgConnOk: 'connection OK',
        helpFlowMsgConnOffline: 'offline',
        helpFlowMsgConnDeaf: 'unstable connection',
        helpFlowMsgOrdersOnScreen: 'no orders on screen | 1 order on screen | {count} orders on screen',
        helpFlowMsgWithoutPhoto: 'none without a photo | 1 without a photo | {count} without a photo',
        helpFlowMsgCodes: 'On screen: {codes}',
        helpFlowMsgManualCount: '1 added by hand | {count} added by hand',
        helpFlowMsgCameraFault: 'Camera: fault {code}',
        helpFlowMsgCameraOk: 'Camera OK ({width}×{height})',
        helpFlowMsgCameraNoPermission: 'Camera: no permission',
        helpFlowMsgCameraPermissionPending: 'Camera: permission prompt unanswered',
        helpFlowMsgCameraRunning: 'Camera running',
        helpFlowMsgCameraStarting: 'Camera: starting up, no image yet',
        helpFlowMsgCameraCount: 'no cameras detected | 1 camera detected | {count} cameras detected',
        helpFlowMsgCameraResolution: 'quality {resolution}px',
        cameraCaptureMethod: 'Capture method',
        cameraCaptureMethodHint: 'Sensor only if the photo cuts off the tray',
        cameraCaptureMethodImageCapture: 'Sensor (wider view, slower)',
        cameraCaptureMethodCanvas: 'Fast (what you see on screen)',
        cameraCaptureMethodImageCaptureShort: 'Sensor',
        cameraCaptureMethodCanvasShort: 'Fast',
        cameraPhotoResolution: 'Photo resolution',
        cameraPhotoResolutionHint: 'Higher: sharper, slower upload',
        cameraPhotoResolutionLow: 'Low',
        cameraPhotoResolutionMedium: 'Medium',
        cameraPhotoResolutionHigh: 'High',
        cameraPhotoResolutionRecommended: 'recommended',
        cameraExposureComp: 'Exposure compensation',
        cameraExposureCompHint: 'Lower if washed out, higher if dark',
        // Black image detection
        retryingCapture: 'Retrying capture...',
        blackImageDetected: 'Could not capture the photo. Check that the camera is not covered and try again.',
        blackImageTitle: 'The photo could not be taken',
        blackImageBody: 'Check that nothing is covering the camera and try again.',
        blackImageDetection: 'Detect black photos',
        blackImageDetectionHint: 'Retakes black photos, up to 2 times',
        // Camera / analysis error popups
        uploadPhotosError: 'Could not upload all the photos. Please try again.',
        analysisIdNotFound: 'No analysis ID found for the order',
        analysisSaveError: 'Error saving the analysis result to IndexedDB',
        analysisFailedRetry: 'The order could not be analyzed. Please try again by tapping the Analyze button.',
        analysisQueuedOffline: 'Order {id}: offline, will analyze on reconnect.',
        analysisQueuedUploading: 'Order {id}: uploading photos, will analyze when done.',
        continueInBackground: 'Continue in background',
        bgAnalysisCorrect: 'Order {id}: correct',
        bgAnalysisMissingDetail: 'Order {id}: {summary}',
        bgAnalysisIncorrect: 'Order {id}: items missing, please check',
        missingVerb: 'missing | missing',
        missingOthers: '1 more item | {count} more items',
        and: 'and',
        tagOffline: 'Offline',
        tagUploading: 'Uploading',
        tagCorrect: 'Correct',
        tagReview: 'Check',
        qrScanPartial: 'The scan arrived cut. Scan the ticket again.',
        qrScanDeliveredTitle: 'Handed to rider',
        qrScanAlreadyTag: 'Already handed',
        qrScanAlreadyBody: 'This order was already closed',
        qrScanNotHere: 'That ticket is not from this store. No order was closed.',
        qrScanOffline: 'No connection: the order could not be checked. Scan the ticket again.',
        qrScanNotSavedTag: 'Not saved',
        qrScanNotSavedBody: 'The hand-over did not reach the server. It will retry when the connection is back, or scan again.',
        qrScanUnknown: 'The scanner read a code that is not an order: {text}',
        qrGunTutorialGroup: 'QR scanner',
        qrGunTutorialSettings: 'How to connect and use the scanner',
        qrGunTutorialSettingsHint: 'Pair it and close orders by scanning',
        qrGunTutorialTitle: 'QR scanner',
        qrGunTutorialExit: 'Exit',
        qrGunTutorialStepOf: 'Step {step} of {total}',
        qrGunTutorialNext: 'Next',
        qrGunTutorialBack: 'Back',
        qrGunTutorialReplay: 'Watch again',
        qrGunTutorialPowerTitle: 'Turn the scanner on',
        qrGunTutorialPowerBody: 'Pull the trigger.',
        qrGunTutorialPowerStrong: 'That way the tablet can find it.',
        qrGunTutorialPairTitle: 'Connect it to the tablet',
        qrGunTutorialPairBody: 'Open the tablet’s Settings → Bluetooth and tap the one that starts with “Hyper 160S”.',
        qrGunTutorialPairNote: 'It shows up with a keyboard icon. When it says “Connected”, you’re done.',
        qrGunTutorialBtTitle: 'Bluetooth',
        qrGunTutorialBtVisible: 'Currently visible to nearby devices.',
        qrGunTutorialBtPaired: 'Paired devices',
        qrGunTutorialBtAvailable: 'Available devices',
        qrGunTutorialBtConnected: 'Connected',
        qrGunTutorialPairNotFound: 'It doesn’t show up',
        qrGunTutorialNotfoundTitle: 'If it doesn’t show up',
        qrGunTutorialNotfoundBody: 'Pull the trigger to turn the scanner on and wait a few seconds.',
        qrGunTutorialNotfoundNote: 'Then look at the Bluetooth list again.',
        qrGunTutorialNotfoundRetry: 'Look again',
        qrGunTutorialBackTitle: 'Come back to Bronze',
        qrGunTutorialBackBody: 'Open Bronze Tracker again. It works as usual.',
        qrGunTutorialBackNote: 'The keyboard is now the scanner. If you need to type, tap the icon on the left of the screen to bring up the keyboard.',
        qrGunTutorialScanTitle: 'Scan the bag',
        qrGunTutorialScanBody: 'When you finish an order, point the scanner at the QR on the bag’s ticket and pull the trigger.',
        qrGunTutorialScanStrong: 'That marks the order as handed to the rider.',
        qrGunTutorialNotifyTitle: 'The tablet tells you',
        qrGunTutorialNotifyBody: 'It plays a sound and shows “Handed to rider” with the order number.',
        qrGunTutorialNotifyNote: 'The scanner also beeps when it reads: that beep only means it has read.',
        qrGunTutorialNotifyListen: 'Hear the sound',
        qrGunTutorialSleepTitle: 'If it falls asleep, wake it up',
        qrGunTutorialSleepBody: 'After about 10 minutes without use, the scanner switches itself off.',
        qrGunTutorialSleepStrong: 'Pull the trigger: within a second it reconnects and beeps. It isn’t broken.',
        qrGunTutorialTestTitle: 'Try it',
        qrGunTutorialTestBody: 'Point the scanner at this code and pull the trigger.',
        qrGunTutorialTestNote: 'Turn the tablet’s brightness up to the maximum: with low brightness the scanner can’t read the screen. No order is closed.',
        qrGunTutorialTestSkip: 'Continue anyway',
        qrGunTutorialTestWaiting: 'Waiting for the scanner…',
        qrGunTutorialTestSuccess: 'It works! The scanner is connected.',
        qrGunTutorialTestOther: 'That is not a Bronze code. Scan the one on the screen.',
        qrGunTutorialTestPartial: 'The scan arrived cut. Scan again.',
        qrGunTutorialDoneTitle: 'All set',
        qrGunTutorialDoneBody: 'The scanner is ready to close orders.',
        qrGunTutorialDoneFinish: 'Finish',
        orderStateCorrect: 'Correct',
        orderStateWrong: 'Incorrect',
        orderStateQueued: 'Queued',
        orderPhotoCount: '{count} photo | {count} photos',
        takePhoto: 'Take the photo',
        bodyQueuedOffline: 'Will analyze on reconnect',
        bodyQueuedUploading: 'Will analyze when done',
        reviewGeneric: 'Items missing',
        // Changelog modal — content comes localised from the feed; these are the chrome.
        changelogTitle: 'What’s new',
        changelogAck: 'Got it',
        changelogSeeAll: 'See all updates',
        changelogSettingsHint: 'What’s new in each version',
        // The design system's catalog (Settings → Debug), docs/sistema-diseno/README.md.
        uiCatalogOpen: 'Design system',
        uiCatalogTitle: 'Design system',
        uiCatalogIntro: 'The app’s colours, type and components, as this tablet draws them.',
        uiCatalogFont: 'Typeface',
        uiCatalogFontHint: 'Comparison: changes the typeface until a reload. All but DM Sans need a connection.',
        uiCatalogFontSystem: 'The system’s',
        uiCatalogFontBrand: 'DM Sans (the chosen one)',
        uiCatalogPalette: 'Colour palette',
        uiCatalogPaletteHint: 'Comparison: changes the colours until a reload.',
        uiCatalogPaletteBronze: 'Bronze (approved)',
        uiCatalogPaletteCurrent: 'The previous one',
        uiCatalogRamps: 'Bronze palette',
        uiCatalogRampsHint: 'Each colour in its steps, from 1 (the darkest) to 12. Step 9 is the fill: in the blue and the yellow it is the exact brand colour (outlined), and the rest is computed from it.',
        uiCatalogRampNames: {
            grey: 'Grey · backgrounds, cards and text',
            blue: 'Blue · action and order to photograph',
            bronze: 'Bronze yellow · brand',
            green: 'Green · correct',
            orange: 'Bronze orange · incorrect',
            amber: 'Amber · warning and delay',
            red: 'Red · rider and sign out',
            slate: 'Slate · queued',
        },
        uiCatalogBrand: 'The brand’s yellow, beside the states',
        uiCatalogBrandHint: 'Only as a fill, on the brand’s own surfaces (start, login, news) and never next to the traffic light. Here beside “check” and the delay, to see they are not confused.',
        uiCatalogVision: 'See as',
        uiCatalogVisionHint: 'Simulates how part of the kitchen sees colour, until you leave this screen. Lists that open are not simulated.',
        uiCatalogVisionNames: {
            normal: 'Normal vision',
            deuteranopia: 'Deuteranopia (green)',
            protanopia: 'Protanopia (red)',
            tritanopia: 'Tritanopia (blue)',
            achromatopsia: 'No colour',
            glare: 'With kitchen glare',
        },
        uiCatalogTrafficLight: 'Order traffic light',
        uiCatalogTrafficLightHint: 'How the order list’s cards would look: each state with its colour, its icon and its word. “See as” reads them with colour blindness or with glare.',
        uiCatalogStateTodo: 'To photograph',
        uiCatalogStatePending: 'Queued',
        uiCatalogColors: 'Colour',
        uiCatalogType: 'Type',
        uiCatalogTypeSample: 'Order ready to hand over',
        uiCatalogButtons: 'Buttons',
        uiCatalogPrimary: 'Main action',
        uiCatalogSecondary: 'Other action',
        uiCatalogText: 'Link',
        uiCatalogOutlined: 'Outlined',
        uiCatalogWithIcon: 'With an icon',
        uiCatalogIcons: 'Icons',
        uiCatalogLists: 'Lists and controls',
        uiCatalogGroup: 'A group',
        uiCatalogDialog: 'Dialog',
        uiCatalogOpenDialog: 'Open a sample dialog',
        uiCatalogDialogEyebrow: 'Sample',
        uiCatalogDialogTitle: 'A dialog of the system',
        uiCatalogDialogSubtitle: 'Title, subtitle and its X',
        uiCatalogDialogBody: 'The body scrolls when it does not fit, and the actions sit at the bottom, 72 px tall.',
        uiCatalogToasts: 'Toasts',
        uiCatalogChips: 'States',
        uiCatalogTiles: 'Tiles',
        uiCatalogChipsHint: 'Two forms of the same tag. Pick by how it will be read: at a glance, or on a screen where the text already says the state.',
        uiCatalogChipsContainer: 'Container',
        uiCatalogChipsContainerHint: 'For a deliberate screen, where the text says the state. Under glare a dark container loses its colour: it never goes alone for something urgent.',
        uiCatalogChipsSolid: 'Solid',
        uiCatalogChipsSolidHint: 'To read at a glance, or for something urgent: a badge over a card, a delay.',
        uiCatalogTilesHint: 'A big button that is a card: its icon in the action blue and its words. The chosen one in the selection\'s blue with its edge.',
        uiCatalogTileStacked: 'Stacked: for a grid of choices',
        uiCatalogTileRow: 'Row: the icon beside the words',
        uiCatalogTileFar: 'Row, to read at a metre',
        uiCatalogEmpty: 'Empty and offline',
        uiCatalogEmptyHint: 'What a list says when it has nothing to show or cannot reach it: a still icon, what is happening and, if there is one, what to do.',
        uiCatalogEmptyTitle: 'Nothing to show',
        uiCatalogEmptyText: 'When there is something, it will appear here.',
        uiCatalogOfflineTitle: 'No connection',
        uiCatalogOfflineText: 'The tablet cannot reach the internet. When it is back, tap Retry.',
        uiCatalogSpinner: 'Loading',
        uiCatalogSpinnerHint: 'Progress with no measure: the icon turns while the app is still trying and the words say what. With «remove animations» it holds still.',
        uiCatalogLoading: 'Loading…',
        uiCatalogSampleNotification: 'Try the notification',
        uiCatalogSampleTitle: 'Test message',
        uiCatalogSampleBody: 'This is how a message Bronze sends to the tablet looks. It is a test: no answer is sent.',
        uiCatalogSampleYes: 'Yes',
        uiCatalogSampleNo: 'No',
        settingsAdvanced: 'Advanced',
        debugHint: 'Camera tests for support',
        debugLane: 'Service screen',
        debugLaneHint: 'Applies when the app reloads',
        demoMode: 'Demo mode',
        demoModeHint: '3 simulated orders; nothing is sent',
        demoActive: 'On: {category} · nothing is sent',
        demoRestart: 'Restart demo',
        demoRestartHint: 'Fresh orders, same type or another',
        demoPickerTitle: 'What kind of restaurant?',
        demoPickerHint: 'We load 3 simulated orders of that kind. Nothing is sent.',
        demoCategoryPizza: 'Pizzas',
        demoCategoryBurger: 'Burgers',
        demoCategoryChicken: 'Fried chicken',
        demoCategorySushi: 'Sushi',
        debugLaneStore: 'As the store has it',
        debugLaneSystem: 'The new one',
        debugLaneCurrent: 'The current one',
        queueEmpty: 'All uploaded',
        queueEmptyHint: 'No photos are waiting to upload.',
        changelogTagNew: 'New',
        changelogTagImproved: 'Improved',
        changelogTagIntegration: 'Integration',
        changelogTagFixed: 'Fixed'
      },
      primevue: {
        aria: {
          close: 'Close'
        },
        emptyMessage: 'No available options',
        emptyFilterMessage: 'No results found',
        emptySearchMessage: 'No results found',
        emptySelectionMessage: 'No selected item',
        searchMessage: '{0} results are available',
        selectionMessage: '{0} items selected'
      }
    },
    fr: {
      message: {
        settings: 'Paramètres',
        deviceId: 'Appareil',
        restaurant: 'Restaurant',
        cameraPermission: 'Autorisation de la caméra',
        flipVertically: 'Mode Périscope™',
        flipVerticallyHint: 'Redresse l’image du support à miroir',
        periscopeTutorialTitle: 'Placer le périscope',
        periscopeTutorialExit: 'Quitter',
        periscopeTutorialStepOf: 'Étape {step} sur {total}',
        periscopeTutorialBack: 'Retour',
        periscopeTutorialReplay: 'Revoir',
        periscopeTutorialSettings: 'Comment placer le Périscope™',
        periscopeTutorialSettingsHint: 'Guide pas à pas avec votre caméra',
        photoVideoTutorialSettings: 'Comment prendre de bonnes photos',
        photoVideoTutorialSettingsHint: 'Vidéo · {duration}',
        photoVideoTutorialTitle: 'Comment prendre de bonnes photos',
        photoVideoTutorialClose: 'Fermer',
        photoVideoTutorialRemaining: 'Il reste {time}',
        photoVideoTutorialLoading: 'Chargement de la vidéo…',
        photoVideoTutorialPause: 'Pause',
        photoVideoTutorialPlay: 'Lecture',
        photoVideoTutorialReplay: 'Revoir',
        photoVideoTutorialRestart: 'Depuis le début',
        photoVideoTutorialErrorTitle: 'Impossible de charger la vidéo',
        photoVideoTutorialErrorBody: 'Vérifie la connexion internet et réessaie.',
        photoVideoTutorialRetry: 'Réessayer',
        periscopeTutorialWelcomeTitle: 'On va placer le périscope',
        periscopeTutorialWelcomeBody: 'C’est le miroir qui se colle dans le coin de la tablette, au-dessus de la caméra. Ça prend quelques minutes.',
        periscopeTutorialWelcomeNote: 'Il n’apparaît que la première fois sur cette tablette. Tu le retrouves aussi dans les Paramètres.',
        periscopeTutorialWelcomeStart: 'Commencer',
        periscopeTutorialWelcomeAlready: 'Il est déjà en place',
        periscopeTutorialNeedsTitle: 'Avant de commencer, prépare ça',
        periscopeTutorialNeedsBody: 'Dans la boîte, il n’y a que le périscope. Le reste, c’est à toi de le prévoir.',
        periscopeTutorialNeedsPeriscope: 'Le périscope',
        periscopeTutorialNeedsAlcohol: 'De l’alcool ou un dégraissant',
        periscopeTutorialNeedsCloth: 'Un chiffon',
        periscopeTutorialNeedsPencil: 'Un crayon ou un marqueur',
        periscopeTutorialNeedsNext: 'J’ai tout',
        periscopeTutorialCleanTitle: 'Nettoie le coin de la caméra',
        periscopeTutorialCleanBody: 'Mets de l’alcool sur le chiffon et nettoie bien la zone où il sera collé : le bord de la tablette à côté de la caméra.',
        periscopeTutorialCleanStrong: 'S’il reste du gras, ça ne colle pas.',
        periscopeTutorialCleanNext: 'C’est propre',
        periscopeTutorialPlaceTitle: 'Pose-le dans le coin, sans le coller',
        periscopeTutorialPlaceBody: 'La base sur le bord et le miroir au-dessus de la caméra.',
        periscopeTutorialPlaceStrong: 'N’enlève pas encore le plastique rouge.',
        periscopeTutorialPlaceInset: 'La caméra regarde le miroir et le miroir regarde la table.',
        periscopeTutorialPlaceCamera: 'Caméra',
        periscopeTutorialPlaceMirror: 'Miroir',
        periscopeTutorialPlaceTable: 'Table',
        periscopeTutorialPlaceNext: 'Suivant',
        periscopeTutorialAlignTitle: 'Bouge-le jusqu’à ne voir que la table',
        periscopeTutorialAlignBody: 'Oriente le miroir vers la table et déplace le périscope petit à petit.',
        periscopeTutorialAlignStrong: 'Rien ne doit se mélanger, ni en haut ni en bas.',
        periscopeTutorialAlignNext: 'C’est bon, on voit bien',
        periscopeTutorialLiveBadge: 'Vraie photo · mise à jour automatique',
        periscopeTutorialLiveAlt: 'Vraie photo de la caméra',
        periscopeTutorialLiveStarting: 'Ouverture de la caméra…',
        periscopeTutorialLiveError: 'Impossible d’ouvrir la caméra.',
        periscopeTutorialLiveRetry: 'Réessayer',
        periscopeTutorialExampleGood: 'Bien : seulement la table',
        periscopeTutorialExampleBadBottom: 'Mal : ça se mélange en bas',
        periscopeTutorialExampleBadTop: 'Mal : ça se mélange en haut',
        periscopeTutorialMarkTitle: 'Marque l’emplacement',
        periscopeTutorialMarkBody: 'Sans le bouger, trace le contour de la base au crayon : les deux côtés et l’arrière.',
        periscopeTutorialMarkNext: 'C’est marqué',
        periscopeTutorialStickTitle: 'Enlève le plastique rouge et colle-le',
        periscopeTutorialStickBody: 'Place-le exactement sur le repère.',
        periscopeTutorialStickStrong: 'Appuie fort pendant quelques secondes.',
        periscopeTutorialStickNext: 'C’est collé',
        periscopeTutorialCheckTitle: 'Vérifie que l’image est bonne',
        periscopeTutorialCheckBody: 'Tu ne vois que la table, sans bande d’autre chose en haut ou en bas ?',
        periscopeTutorialCheckYes: 'Oui, c’est bon',
        periscopeTutorialCheckNo: 'Non, il faut le bouger',
        periscopeTutorialUnstickTitle: 'Décolle-le en le tournant',
        periscopeTutorialUnstickBody: 'Fais tourner le périscope sur lui-même, un tour complet, jusqu’à ce qu’il se décolle.',
        periscopeTutorialUnstickNext: 'C’est décollé',
        periscopeTutorialRestickTitle: 'Recolle-le sur le repère',
        periscopeTutorialRestickBody: 'Place-le exactement sur le repère.',
        periscopeTutorialRestickBad: 'Ça ne colle pas bien',
        periscopeTutorialRetapeTitle: 'Change l’adhésif',
        periscopeTutorialRetapeBody: 'Achète du ruban adhésif double face. Enlève le vieil adhésif de la base et colle un morceau neuf de la même taille.',
        periscopeTutorialRetapeNext: 'Il a un adhésif neuf',
        periscopeTutorialDoneTitle: 'Périscope en place !',
        periscopeTutorialDoneBody: 'On a activé le Mode Périscope™ pour que l’image soit à l’endroit.',
        periscopeTutorialDoneBody2: 'Tu peux maintenant mettre la tablette sur son support.',
        periscopeTutorialDoneFinish: 'Terminer',
        immersiveViewport: 'Mode caméra immersif',
        immersiveViewportHint: 'La caméra en plein écran',
        immersiveViewportModalTitle: 'Mode caméra immersif activé',
        immersiveViewportModalBody: 'La caméra s’affiche désormais en plus grand et les boutons apparaissent par-dessus l’image. Si tu préfères revenir à la version précédente, désactive l’option dans les Paramètres.',
        immersiveViewportModalButton: 'Compris',
        signOut: 'Se déconnecter',
        signOutHint: 'Pour revenir, il faudra le code',
        general: 'Général',
        camera: 'Caméra',
        cameraHint: 'Automatique : celle de derrière',
        signIn: 'Se connecter',
        signingIn: 'Connexion...',
        queue: 'File d’envoi',
        photo: 'Photo',
        analyze: 'Analyser',
        photoAndAnalyze: 'Photo et analyse',
        retakeReminder: 'Pense à revenir prendre la photo et analyser',
        retakeReminderTitle: 'Commande {code} pas encore corrigée',
        retakeReminderBody: 'Rouvre-la, prends la photo et appuie sur Analyser.',
        retakeAimTitle: 'Prends la photo de :',
        retakeAimFoot: 'puis appuie sur Analyser pour continuer',
        avoidDuplicatePhotos: 'Évite de reprendre la même photo',
        imagesLeftToUpload: 'Photos restantes à envoyer',
        cancelAnalysis: 'Annuler l’analyse',
        back: 'Retour',
        timeout: 'Impossible d’analyser le contenu de la commande.',
        accept: 'Valider',
        analyzing: 'Analyse de la commande...',
        analysisError: 'Erreur lors de l’analyse de la commande',
        close: 'Fermer',
        checkOrder: 'Vérifier la commande',
        missingItems: 'Produits manquants',
        notDetected: '{count} produit manquant | {count} produits manquants',
        notDetectedSubtitleSingle: 'Vérifie la commande avant de fermer le sac',
        missingCount: '{count} manquant | {count} manquants',
        stillContinue: 'Livrer sans corriger',
        stillContinueWarning: 'Le client risque de se plaindre',
        addPhotos: 'Corriger et reprendre une photo',
        itemNotDetectedInPhoto: 'Un de ces produits n’a pas été détecté | {count} de ces produits n’ont pas été détectés',
        perfect: 'Tout est parfait !',
        finalize: 'Terminer',
        help: 'Aide',
        helpPrefill: 'Bonjour, c’est l’équipe cuisine de {store}. Nous avons besoin d’aide pour : ',
        noOrders: 'Aucune commande pour le moment',
        resolution: 'Résolution',
        cameraDefault: 'Automatique',
        uploadQueue: 'File d’envoi',
        debug: 'Débogage',
        version: 'Version',
        madeWithLove: 'Fait avec ❤️ en Espagne',
        confirmSignOut: 'Es-tu sûr de vouloir te déconnecter ?',
        reload: 'Recharger',
        clearCache: 'Vider le cache',
        sessionExpired: 'Session expirée, redirection vers la connexion',
        newServiceWorker: 'Nouvelle version détectée. Préparation de la mise à jour...',
        errorLoadingSettings: 'Erreur lors du chargement des paramètres',
        indexedDBCleared: 'Base de données locale vidée avec succès',
        errorClearingIndexedDB: 'Erreur lors du vidage de la base de données locale',
        loading: 'Chargement...',
        startupConnecting: 'Connexion à ton restaurant…',
        loadingTakingLong: 'C’est plus long que d’habitude',
        retryingAutomatically: 'On réessaie automatiquement. Tu n’as rien à faire.',
        startupAutoReloadIn: 'L’application va redémarrer toute seule dans {s} s',
        startupRestarting: 'Redémarrage de l’application…',
        startupFailedTitle: 'Pas de connexion',
        startupFailedBody: 'On a arrêté de réessayer. Vérifie le Wi-Fi du restaurant et appuie sur Réessayer. Si ça ne marche toujours pas, préviens ton manager.',
        startupDeviceMeta: 'Appareil : {id} · v{version}',
        retryStartup: 'Réessayer',
        deviceIdChanged: 'L’identifiant de cet appareil a changé. Saisis le nouvel identifiant et son code pour te reconnecter.',
        otpCode: 'Code OTP',
        needHelp: 'Besoin d’aide ?',
        loginSuccessful: 'Connexion réussie !',
        sessionExpiredRelogin: 'Ta session a expiré. Merci de te reconnecter.',
        errorOccurred: 'Une erreur est survenue. Merci de réessayer.',
        incorrectCredentials: 'Connexion impossible. Vérifie l’appareil et le code OTP.',
        userNotFound: 'Erreur de connexion : utilisateur introuvable.',
        invalidOTP: 'Erreur de connexion : code OTP invalide.',
        hideTicket: 'Masquer',
        showTicket: 'Ticket',
        listView: 'Liste',
        groupView: 'Groupe',
        allergiesLabel: 'ALLERGIES',
        commentsLabel: 'COMMENTAIRES',
        contentNotAvailable: 'Contenu non disponible',
        uploadTakingTooLong: 'L’envoi prend un peu plus de temps…',
        analysisTakingTooLong: 'L’analyse prend plus de temps que prévu\nMerci de vérifier ta connexion internet',
        unknown: 'Inconnu',
        unknownOrder: 'Commande inconnue',
        messageFrom: 'Message de',
        secondsRemaining: 'secondes restantes',
        justNow: 'À l’instant',
        minuteAgo: 'Il y a 1 min',
        minutesAgo: 'Il y a {minutes} min',
        // Camera preview literals
        initializingCamera: 'Démarrage de la caméra...',
        startCamera: 'Démarrer la caméra',
        cameraFaultPermissionTitle: 'Autorisation caméra manquante',
        cameraFaultPermissionBlockedBody: "Le navigateur bloque la caméra pour Bronze. Appuie sur le cadenas à côté de l'adresse, mets Caméra sur « Autoriser », puis réessaie.",
        cameraFaultPermissionPendingBody: "Le navigateur a demandé l'autorisation d'utiliser la caméra et personne n'a répondu. Appuie sur « Autoriser » dans le message en haut.",
        cameraFaultBusyAppTitle: 'La caméra est occupée',
        cameraFaultBusyAppBody: 'Une autre application de la tablette utilise la caméra. Ferme-la depuis les applications récentes et réessaie. Si le problème persiste, redémarre la tablette.',
        cameraFaultOtherWindowTitle: 'Bronze est ouvert deux fois',
        cameraFaultOtherWindowBody: "Bronze Tracker est ouvert dans une autre fenêtre ou un autre onglet, et une seule peut utiliser la caméra. Ferme l'autre et réessaie.",
        cameraFaultNeedsTapTitle: 'Appuie pour activer la caméra',
        cameraFaultNeedsTapBody: "Le navigateur a besoin que tu touches l'écran avant de démarrer la caméra. Appuie sur le bouton ci-dessous.",
        cameraFaultNoCameraTitle: 'Aucune caméra détectée',
        cameraFaultNoCameraBody: "Cette tablette n'expose aucune caméra. Vérifie qu'elle n'est pas désactivée dans les paramètres de l'appareil.",
        cameraFaultUnknownTitle: "Impossible de démarrer la caméra",
        cameraFaultUnknownBody: 'Réessaie. Si elle ne démarre pas, redémarre la tablette et transmets le code ci-dessous au support.',
        cameraRetryAttempt: 'Nouvelle tentative… ({attempt}/{total})',
        cancel: 'Annuler',
        more: 'de plus',
        photoDiscarded: 'Photo supprimée',
        capturing: 'Capture...',
        // Manual order
        manualOrderAdd: 'Ajouter une commande',
        manualOrderAddFull: 'Ajouter une commande manuellement',
        manualOrderTitle: 'Commande manuelle',
        manualOrderSelectPlatform: 'De quelle plateforme vient la commande ?',
        manualOrderEnterCode: 'Saisis le code de la commande',
        manualOrderEnterCodeN: 'Saisis le code de commande à {n} chiffres',
        manualOrderEnterCodeCharsN: 'Saisis le code de commande à {n} caractères',
        manualOrderEnterOrderSuffixN: 'Saisis les {n} derniers chiffres de la commande',
        manualOrderEnterCodeDeliveroo: 'Saisis les 3 ou 4 chiffres du code (imprimé avec # sur le ticket)',
        manualOrderInvalidCode: 'Le code n’est pas valide',
        manualOrderCreating: 'Création de la commande...',
        manualOrderErrorTitle: 'Impossible de créer la commande',
    manualOrderError: 'Réessaie.',
        manualOrderExistsOpened: 'Cette commande existait déjà. Nous l’avons ouverte.',
        manualOrderExistsLooking: 'Recherche de la commande...',
        manualOrderExistsOtherPlatform: 'Ce code est déjà enregistré chez {platform}, pas sur la plateforme que tu as choisie. Vérifie la plateforme et saisis-le de nouveau.',
        manualOrderExistsNotFoundTitle: 'Cette commande existe déjà',
        manualOrderExistsNotFoundBody: 'Ce code est déjà enregistré, mais nous ne le trouvons pas sur la tablette. Appuie sur Aide et dis-nous quelle plateforme et quel code tu as saisi.',
        manualOrderOwnDelivery: 'Livraison interne',
        manualOrderTakeAway: 'À emporter',
        manualOrderLoadingPlatforms: 'Chargement des plateformes...',
        manualOrderNoPlatforms: 'Aucune plateforme configurée pour ce restaurant.',
        manualOrderLoadError: 'Impossible de charger les plateformes. Réessaie.',
        manualOrderRetry: 'Réessayer',
        // Rider check-in
        riderArrivedTitle: 'Nouveau livreur',
        riderArrivedBody: 'Le livreur de la commande {orderId} attend',
        riderIsHere: 'Livreur',
        riderReminderTitle: 'Toujours en attente',
        riderReminderBody: 'Le livreur de la commande {orderId} attend depuis {minutes} min',
        ridersWaiting: '{count} livreur en attente | {count} livreurs en attente',
        riderOrderDeliveredTitle: 'Livré',
        riderWaitMinutes: '{minutes} min d’attente',
        riderJustArrived: 'Vient d’arriver',
        ridersPopupTitle: 'Livreurs',
        ridersPopupWaiting: 'En attente',
        ridersPopupDelivered: 'Livrées',
        ridersPopupEmptyWaiting: 'Aucun livreur en attente',
        ridersPopupEmptyDelivered: 'Aucune commande livrée pour le moment',
        ridersPopupClose: 'Fermer',
        ridersPopupDeliveredAt: 'Livré à {time} · il y a {minutes} min',
        ridersPopupDeliveredJustNow: 'Livré à {time} · à l’instant',
        // Photo coverage alert (local kitchen nudge)
        coverageAlertStatus: 'Dernière commande sans photo | {count} dernières commandes sans photo',
        coverageAlertTitle: 'On reprend les photos ?',
        coverageAlertAck: 'Oui, dès la prochaine commande',
        coverageAlertCant: 'Pas maintenant',
        coverageAlertReasonTitle: 'Qu’est-ce qui se passe ?',
        coverageAlertBusy: 'On est débordés',
        coverageAlertBusyHint: 'On reprend après le rush',
        coverageAlertSupport: 'La tablette a un problème',
        coverageAlertSupportHint: 'Ouvrir l’assistance',
        coverageAlertBack: 'Retour',
        coverageAlertDismiss: 'Fermer l’alerte',
        coverageSupportPrefill: 'Bonjour, c’est l’équipe cuisine de {store}. Nous avons besoin d’aide pour prendre les commandes en photo. Il y a actuellement {count} commandes sans photo. Pouvez-vous nous aider ?',
        coverageThanks: 'Photos à jour. Merci !',
        // --- Guided flow modal (shared shell: help today, AI-wrong next) ---
        guidedFlowYes: 'Oui, c’est bon',
        guidedFlowNo: 'Non, prévenir l’assistance',
        guidedFlowBack: 'Retour',
        guidedFlowRetry: 'Réessayer',
        guidedFlowReloadApp: 'Recharger l’app',
        guidedFlowUnavailableTitle: 'Impossible d’ouvrir le chat d’assistance pour le moment',
        guidedFlowUnavailableOffline: 'La tablette est hors ligne. Quand elle revient, touche Réessayer.',
        guidedFlowUnavailableMessenger: 'Le chat n’a pas chargé. Essaie de recharger l’app.',
        // --- Help flow: the six one-tap topics + free text (helpFlow.js) ---
        helpFlowTitle: 'On t’aide avec quoi ?',
        helpFlowTopicMissingOrder: 'Une commande n’apparaît pas',
        helpFlowTopicItemFlaggedPresent: 'Il indique qu’un produit manque alors qu’il est là',
        helpFlowTopicCannotTakePhoto: 'Je ne peux pas prendre la photo',
        helpFlowTopicSeeOrderPhotos: 'Je veux voir les photos d’une commande',
        helpFlowTopicUnexpectedOrders: 'Des commandes qui ne devraient pas apparaître s’affichent',
        helpFlowTopicLeftWithoutPhoto: 'La commande est partie sans photo',
        helpFlowTopicOther: 'Autre chose',
        helpFlowTopicVoiceNote: 'Envoyer un message vocal',
        helpFlowPickTitle: 'Quelle commande ?',
        helpFlowPickFlaggedTitle: 'Sur quelle commande l’app dit-elle qu’il manque quelque chose ?',
        helpFlowPickNoPhotoTitle: 'Quelle commande est partie sans photo ?',
        helpFlowPickNoPhotoEmpty: 'Il n’y a pas de commande récente sans photo.',
        helpFlowPickTypeCode: 'Saisir le code',
        helpFlowCodeTitle: 'Quel est le code de la commande ?',
        helpFlowCodeHint: 'Tu le trouveras sur le ticket ou sur le sac.',
        helpFlowCodePlaceholder: 'Code de la commande',
        helpFlowCodeSkip: 'Je ne l’ai pas',
        helpFlowMsgOrderTyped: 'Commande {code} (saisie à la main sur la tablette).',
        helpFlowPickNone: 'Elle n’est pas dans la liste',
        helpFlowBadgeIncorrect: 'IA : produit manquant',
        helpFlowBadgeCorrect: 'Correcte',
        helpFlowBadgePending: 'Photo prise, pas encore de résultat',
        helpFlowBadgeNoPhoto: 'Sans photo',
        helpFlowWorkingReload: 'On va redémarrer l’app…',
        helpFlowWorkingSub: 'Ça prend quelques secondes. Au retour, on te demande si c’est réglé.',
        helpFlowConfirmSub: 'On a rechargé l’app.',
        helpFlowConfirmMissingOrder: 'La commande apparaît maintenant ?',
        helpFlowConfirmCamera: 'La caméra fonctionne maintenant ?',
        helpFlowEvidenceOrders: 'Aucune commande à l’écran pour l’instant | 1 commande à l’écran pour l’instant | {count} commandes à l’écran pour l’instant',
        helpFlowEvidenceCameraOk: 'La caméra est en marche',
        helpFlowEvidenceCameraFault: 'La caméra ne marche toujours pas : {code}',
        helpFlowResolvedToast: 'Réglé ! Si ça se reproduit, préviens-nous.',
        helpFlowSentToast: 'Envoyé à l’assistance. On te répond dans le chat.',
        helpVoiceSpeakNow: 'Parle maintenant. Quand tu as fini, arrête l’enregistrement et appuie sur envoyer.',
        helpVoiceTapMic: 'Si ça n’enregistre pas, touche le micro du chat.',
        // --- Help flow : voir les photos d’une commande (orderPhotos.js, visionneuse dans la modale) ---
        helpPhotosPickTitle: 'De quelle commande veux-tu voir les photos ?',
        helpPhotosLoading: 'On cherche les dernières commandes…',
        helpPhotosEmpty: 'Il n’y a pas encore de commande avec photo.',
        helpPhotosFailed: 'Impossible de charger les commandes.',
        helpPhotosMore: 'Voir les commandes précédentes',
        helpPhotosAskSupport: 'Les demander à l’assistance',
        helpPhotosCount: '1 photo | {count} photos',
        helpPhotosBadgeNoResult: 'Sans résultat',
        orderPhotosCounter: 'Photo {index} sur {count}',
        orderPhotosAlt: 'Photo {index} de la commande {code}',
        orderPhotosPrev: 'Photo précédente',
        orderPhotosNext: 'Photo suivante',
        orderPhotosImageFailed: 'Impossible de charger la photo',
        orderPhotosLoadFailed: 'Impossible de charger les photos de cette commande.',
        orderPhotosNone: 'Cette commande n’a pas encore de photo dans le système.',
        orderPhotosNoneHint: 'Si tu viens de les prendre, elles mettent quelques secondes à s’envoyer.',
        orderPhotosOtherOrders: 'Voir d’autres commandes',
        orderPhotosCheckAgain: 'Vérifier à nouveau',
        orderPhotosLoading: 'Chargement des photos…',
        orderPhotosOffline: 'Pas de connexion',
        orderPhotosSupport: 'Un souci ? Écrire à l’assistance',
        orderPhotosJustNow: 'à l’instant',
        orderPhotosMinutesAgo: 'il y a {minutes} min',
        orderPhotosYesterday: 'hier, {time}',
        orderPhotosDate: '{date}, {time}',
        // --- Login help: message contextuel à l’assistance (loginHelp.js) ---
        loginHelpIntro: 'Bonjour, l’équipe cuisine n’arrive pas à se connecter sur la tablette.',
        loginHelpAttempt: 'Elle essaie de se connecter avec l’appareil {device} et le code {otp}, mais ça ne marche pas.',
        loginHelpNoDevice: '(aucun appareil)',
        loginHelpNoOtp: '(aucun code)',
        loginHelpError: 'L’erreur affichée : {error}.',
        loginHelpLastLogin: 'La dernière connexion réussie sur cette tablette était avec {device} ({restaurant}), {age}.',
        loginHelpUnknownRestaurant: 'restaurant inconnu',
        loginHelpNoHistory: 'Aucune connexion réussie précédente n’est enregistrée sur cette tablette.',
        loginHelpJustNow: 'à l’instant',
        loginHelpMinutesAgo: 'il y a {minutes} min',
        loginHelpHoursAgo: 'il y a {hours} h',
        loginHelpDaysAgo: 'il y a {days} jours',
        loginHelpTech: 'Login · v{version}',
        loginHelpSentToast: 'Envoyé à l’assistance. On te répond dans le chat.',
        loginHelpUnavailable: 'Impossible d’ouvrir le chat. Vérifie la connexion.',
        // The support message the composer opens with (composeHelpMessage)
        aiWrongTitle: 'Que s’est-il passé avec ce produit ? | Que s’est-il passé avec ces produits ?',
        aiWrongWasThere: 'Tout y était, il ne l’a pas détecté',
        aiWrongDifferentPackaging: 'Je l’ai emballé autrement',
        aiWrongOutOfStock: 'Rupture de stock',
        aiWrongSkip: 'Fermer',
        aiWrongBack: 'Retour',
        aiWrongSentToast: 'Merci, on le transmet à l’équipe.',
        aiWrongMsgWasThere: 'L’app dit qu’un produit manque, mais tout était dans le sac et il ne l’a pas détecté.',
        aiWrongMsgDifferentPackaging: 'L’app dit qu’un produit manque, mais on l’a emballé autrement.',
        aiWrongMsgOutOfStock: 'L’app dit qu’un produit manque, mais il y a eu une rupture de stock.',
        aiWrongMsgItems: 'Produits signalés comme manquants : {items}.',
        helpFlowMsgIntro: 'Bonjour, on écrit depuis Bronze Tracker (la tablette de cuisine) de {store}.',
        helpFlowMsgPlatform: 'La commande vient de {platform}.',
        helpFlowMsgOrderList: 'La commande qui ne devrait pas être là : {codes} | Les {count} commandes qui ne devraient pas être là : {codes}',
        helpFlowPickPlatformTitle: 'De quel agrégateur vient la commande ?',
        helpFlowPickPlatformNone: 'Je ne sais pas',
        helpFlowPickOrdersTitle: 'Lesquelles ne devraient pas être là ?',
        helpFlowPickOrdersHint: 'Tu peux en cocher plusieurs',
        helpFlowComposeTitle: 'Qu’est-ce qui se passe ?',
        helpFlowComposePlaceholder: 'Raconte-le avec tes mots…',
        helpFlowComposeSend: 'Envoyer à l’assistance',
        helpFlowMsgMissingOrder: 'Une commande n’apparaît pas sur la tablette.',
        helpFlowMsgItemFlaggedPresent: 'L’app indique qu’un produit manque, mais il est dans le sac.',
        helpFlowMsgCannotTakePhoto: 'Nous ne pouvons pas prendre la photo.',
        helpFlowMsgSeeOrderPhotos: 'Nous voulons voir les photos d’une commande.',
        helpFlowMsgSeeOrderPhotosViewed: 'Nous avons regardé les photos de cette commande et nous avons besoin d’aide.',
        helpFlowMsgUnexpectedOrders: 'Des commandes qui ne devraient pas être là s’affichent.',
        helpFlowMsgLeftWithoutPhoto: 'Une commande est partie sans photo.',
        helpFlowMsgVoiceNote: 'On vous l’explique dans un message vocal.',
        helpFlowMsgOrder: 'Commande {code}',
        helpFlowMsgAnalysis: 'analyse {id}',
        helpFlowMsgManualOrder: 'ajoutée à la main',
        helpFlowMsgRemedyReload: 'Nous avons déjà rechargé l’app et c’est toujours pareil.',
        helpFlowMsgTech: 'Tablette {device} · v{version}',
        helpFlowMsgConnOk: 'connexion OK',
        helpFlowMsgConnOffline: 'hors ligne',
        helpFlowMsgConnDeaf: 'connexion instable',
        helpFlowMsgOrdersOnScreen: 'aucune commande à l’écran | 1 commande à l’écran | {count} commandes à l’écran',
        helpFlowMsgWithoutPhoto: 'aucune sans photo | 1 sans photo | {count} sans photo',
        helpFlowMsgCodes: 'À l’écran : {codes}',
        helpFlowMsgManualCount: '1 ajoutée à la main | {count} ajoutées à la main',
        helpFlowMsgCameraFault: 'Caméra : erreur {code}',
        helpFlowMsgCameraOk: 'Caméra OK ({width}×{height})',
        helpFlowMsgCameraNoPermission: 'Caméra : pas d’autorisation',
        helpFlowMsgCameraPermissionPending: 'Caméra : autorisation sans réponse',
        helpFlowMsgCameraRunning: 'Caméra en marche',
        helpFlowMsgCameraStarting: 'Caméra : en cours de démarrage, pas encore d’image',
        helpFlowMsgCameraCount: 'aucune caméra détectée | 1 caméra détectée | {count} caméras détectées',
        helpFlowMsgCameraResolution: 'qualité {resolution}px',
        cameraCaptureMethod: 'Méthode de capture',
        cameraCaptureMethodHint: 'Capteur, seulement si la photo coupe le plateau',
        cameraCaptureMethodImageCapture: 'Capteur (champ plus large, plus lent)',
        cameraCaptureMethodCanvas: 'Rapide (ce que tu vois à l’écran)',
        cameraCaptureMethodImageCaptureShort: 'Capteur',
        cameraCaptureMethodCanvasShort: 'Rapide',
        cameraPhotoResolution: 'Résolution des photos',
        cameraPhotoResolutionHint: 'Plus haute : plus nette, envoi plus lent',
        cameraPhotoResolutionLow: 'Basse',
        cameraPhotoResolutionMedium: 'Moyenne',
        cameraPhotoResolutionHigh: 'Haute',
        cameraPhotoResolutionRecommended: 'recommandée',
        cameraExposureComp: 'Compensation d’exposition',
        cameraExposureCompHint: 'Moins si surexposé, plus si sombre',
        // Black image detection
        retryingCapture: 'Nouvelle tentative de capture...',
        blackImageDetected: 'Impossible de capturer la photo. Vérifie que la caméra n’est pas obstruée et réessaie.',
        blackImageTitle: 'Impossible de prendre la photo',
        blackImageBody: 'Vérifie que rien ne cache la caméra et réessaie.',
        blackImageDetection: 'Détecter les photos noires',
        blackImageDetectionHint: 'Reprend les photos noires, jusqu’à 2 fois',
        // Camera / analysis error popups
        uploadPhotosError: 'Impossible d’envoyer toutes les photos. Réessaie.',
        analysisIdNotFound: 'Aucun identifiant d’analyse trouvé pour la commande',
        analysisSaveError: 'Erreur lors de l’enregistrement du résultat de l’analyse',
        analysisFailedRetry: 'Impossible d’analyser la commande. Réessaie en appuyant sur le bouton Analyser.',
        analysisQueuedOffline: 'Commande {id} : hors ligne, analyse à la reconnexion.',
        analysisQueuedUploading: 'Commande {id} : envoi des photos, analyse ensuite.',
        continueInBackground: 'Continuer en arrière-plan',
        bgAnalysisCorrect: 'Commande {id} : correcte',
        bgAnalysisMissingDetail: 'Commande {id} : {summary}',
        bgAnalysisIncorrect: 'Commande {id} : produits manquants, à vérifier',
        missingVerb: 'manque | manquent',
        missingOthers: '1 autre produit | {count} autres produits',
        and: 'et',
        tagOffline: 'Hors ligne',
        tagUploading: 'Envoi',
        tagCorrect: 'Correct',
        tagReview: 'À vérifier',
        qrScanPartial: 'La lecture est arrivée coupée. Scanne à nouveau le ticket.',
        qrScanDeliveredTitle: 'Remis au livreur',
        qrScanAlreadyTag: 'Déjà remis',
        qrScanAlreadyBody: 'Cette commande était déjà clôturée',
        qrScanNotHere: 'Ce ticket n’est pas de ce restaurant. Aucune commande n’a été clôturée.',
        qrScanOffline: 'Pas de connexion : la commande n’a pas pu être vérifiée. Scanne à nouveau le ticket.',
        qrScanNotSavedTag: 'Non enregistré',
        qrScanNotSavedBody: 'La remise n’est pas arrivée au serveur. Nouvel essai au retour de la connexion, ou scanne à nouveau.',
        qrScanUnknown: 'La douchette a lu un code qui n’est pas une commande : {text}',
        qrGunTutorialGroup: 'Douchette QR',
        qrGunTutorialSettings: 'Comment connecter et utiliser la douchette',
        qrGunTutorialSettingsHint: 'L’associer et clôturer les commandes en scannant',
        qrGunTutorialTitle: 'Douchette QR',
        qrGunTutorialExit: 'Quitter',
        qrGunTutorialStepOf: 'Étape {step} sur {total}',
        qrGunTutorialNext: 'Suivant',
        qrGunTutorialBack: 'Retour',
        qrGunTutorialReplay: 'Revoir',
        qrGunTutorialPowerTitle: 'Allume la douchette',
        qrGunTutorialPowerBody: 'Appuie sur la gâchette.',
        qrGunTutorialPowerStrong: 'Comme ça, la tablette peut la trouver.',
        qrGunTutorialPairTitle: 'Connecte-la à la tablette',
        qrGunTutorialPairBody: 'Ouvre les Paramètres de la tablette → Bluetooth et touche celle qui commence par « Hyper 160S ».',
        qrGunTutorialPairNote: 'Elle apparaît avec une icône de clavier. Quand c’est écrit « Connecté », c’est bon.',
        qrGunTutorialBtTitle: 'Bluetooth',
        qrGunTutorialBtVisible: 'Actuellement visible par les appareils à proximité.',
        qrGunTutorialBtPaired: 'Appareils associés',
        qrGunTutorialBtAvailable: 'Appareils disponibles',
        qrGunTutorialBtConnected: 'Connecté',
        qrGunTutorialPairNotFound: 'Elle n’apparaît pas',
        qrGunTutorialNotfoundTitle: 'Si elle n’apparaît pas',
        qrGunTutorialNotfoundBody: 'Appuie sur la gâchette pour allumer la douchette et attends quelques secondes.',
        qrGunTutorialNotfoundNote: 'Regarde ensuite à nouveau la liste Bluetooth.',
        qrGunTutorialNotfoundRetry: 'Chercher à nouveau',
        qrGunTutorialBackTitle: 'Reviens dans Bronze',
        qrGunTutorialBackBody: 'Rouvre Bronze Tracker. Il fonctionne comme d’habitude.',
        qrGunTutorialBackNote: 'Le clavier, c’est maintenant la douchette. Si tu dois écrire, touche l’icône à gauche de l’écran pour faire apparaître le clavier.',
        qrGunTutorialScanTitle: 'Scanne le sac',
        qrGunTutorialScanBody: 'Quand tu as fini une commande, pointe la douchette vers le QR du ticket sur le sac et appuie sur la gâchette.',
        qrGunTutorialScanStrong: 'Ainsi, la commande est remise au livreur.',
        qrGunTutorialNotifyTitle: 'La tablette te prévient',
        qrGunTutorialNotifyBody: 'Un son retentit et « Remis au livreur » s’affiche avec le numéro de la commande.',
        qrGunTutorialNotifyNote: 'La douchette bipe aussi à la lecture : ce bip dit seulement qu’elle a lu.',
        qrGunTutorialNotifyListen: 'Écouter le son',
        qrGunTutorialSleepTitle: 'Si elle s’endort, réveille-la',
        qrGunTutorialSleepBody: 'Après environ 10 minutes sans l’utiliser, la douchette s’éteint toute seule.',
        qrGunTutorialSleepStrong: 'Appuie sur la gâchette : en une seconde elle se reconnecte et bipe. Elle n’est pas cassée.',
        qrGunTutorialTestTitle: 'Teste-la',
        qrGunTutorialTestBody: 'Pointe la douchette vers ce code et appuie sur la gâchette.',
        qrGunTutorialTestNote: 'Mets la luminosité de la tablette au maximum : avec peu de luminosité, la douchette ne lit pas l’écran. Aucune commande n’est clôturée.',
        qrGunTutorialTestSkip: 'Continuer quand même',
        qrGunTutorialTestWaiting: 'En attente de la douchette…',
        qrGunTutorialTestSuccess: 'Ça marche ! La douchette est connectée.',
        qrGunTutorialTestOther: 'Ce n’est pas un code Bronze. Scanne celui de l’écran.',
        qrGunTutorialTestPartial: 'La lecture est arrivée coupée. Scanne à nouveau.',
        qrGunTutorialDoneTitle: 'C’est prêt',
        qrGunTutorialDoneBody: 'La douchette est prête à clôturer les commandes.',
        qrGunTutorialDoneFinish: 'Terminer',
        orderStateCorrect: 'Correct',
        orderStateWrong: 'Incorrect',
        orderStateQueued: 'En attente',
        orderPhotoCount: '{count} photo | {count} photos',
        takePhoto: 'Prendre la photo',
        bodyQueuedOffline: 'Analyse à la reconnexion',
        bodyQueuedUploading: 'Analyse une fois terminé',
        reviewGeneric: 'Produits manquants',
        // Changelog modal — content comes localised from the feed; these are the chrome.
        changelogTitle: 'Nouveautés',
        changelogAck: 'Compris',
        changelogSeeAll: 'Voir toutes les nouveautés',
        changelogSettingsHint: 'Les nouveautés de chaque version',
        // The design system's catalog (Settings → Debug), docs/sistema-diseno/README.md.
        uiCatalogOpen: 'Système de design',
        uiCatalogTitle: 'Système de design',
        uiCatalogIntro: 'Les couleurs, la typographie et les composants de l’app, tels que cette tablette les affiche.',
        uiCatalogFont: 'Typographie',
        uiCatalogFontHint: 'Comparaison : change la police jusqu’au rechargement. Toutes sauf DM Sans demandent une connexion.',
        uiCatalogFontSystem: 'Celle du système',
        uiCatalogFontBrand: 'DM Sans (celle choisie)',
        uiCatalogPalette: 'Palette de couleurs',
        uiCatalogPaletteHint: 'Comparaison : change les couleurs jusqu’au rechargement.',
        uiCatalogPaletteBronze: 'Bronze (approuvée)',
        uiCatalogPaletteCurrent: 'L’ancienne',
        uiCatalogRamps: 'Palette Bronze',
        uiCatalogRampsHint: 'Chaque couleur en ses paliers, du 1 (le plus sombre) au 12. Le 9 est le remplissage : pour le bleu et le jaune, c’est la couleur exacte de la marque (encadrée), et le reste est calculé à partir d’elle.',
        uiCatalogRampNames: {
            grey: 'Gris · fonds, cartes et texte',
            blue: 'Bleu · action et commande à photographier',
            bronze: 'Jaune Bronze · marque',
            green: 'Vert · correct',
            orange: 'Orange bronze · incorrect',
            amber: 'Ambre · alerte et retard',
            red: 'Rouge · livreur et déconnexion',
            slate: 'Ardoise · en attente',
        },
        uiCatalogBrand: 'Le jaune de la marque, à côté des états',
        uiCatalogBrandHint: 'Seulement en aplat, sur les surfaces de la marque (démarrage, connexion, nouveautés) et jamais à côté du code couleur. Ici, à côté de « à vérifier » et du retard, pour voir qu’on ne les confond pas.',
        uiCatalogVision: 'Voir comme',
        uiCatalogVisionHint: 'Simule la façon dont une partie de la cuisine voit les couleurs, jusqu’à ce que tu quittes cet écran. Les listes qui s’ouvrent ne sont pas simulées.',
        uiCatalogVisionNames: {
            normal: 'Vision normale',
            deuteranopia: 'Deutéranopie (vert)',
            protanopia: 'Protanopie (rouge)',
            tritanopia: 'Tritanopie (bleu)',
            achromatopsia: 'Sans couleur',
            glare: 'Avec le reflet de la cuisine',
        },
        uiCatalogTrafficLight: 'Code couleur des commandes',
        uiCatalogTrafficLightHint: 'L’allure qu’auraient les cartes de la liste des commandes : chaque état avec sa couleur, son icône et son mot. « Voir comme » les montre avec un daltonisme ou avec un reflet.',
        uiCatalogStateTodo: 'À photographier',
        uiCatalogStatePending: 'En attente',
        uiCatalogColors: 'Couleur',
        uiCatalogType: 'Typographie',
        uiCatalogTypeSample: 'Commande prête à remettre',
        uiCatalogButtons: 'Boutons',
        uiCatalogPrimary: 'Action principale',
        uiCatalogSecondary: 'Autre action',
        uiCatalogText: 'Lien',
        uiCatalogOutlined: 'Contour',
        uiCatalogWithIcon: 'Avec icône',
        uiCatalogIcons: 'Icônes',
        uiCatalogLists: 'Listes et contrôles',
        uiCatalogGroup: 'Un groupe',
        uiCatalogDialog: 'Boîte de dialogue',
        uiCatalogOpenDialog: 'Ouvrir une boîte de dialogue d’exemple',
        uiCatalogDialogEyebrow: 'Exemple',
        uiCatalogDialogTitle: 'Une boîte de dialogue du système',
        uiCatalogDialogSubtitle: 'Titre, sous-titre et son X',
        uiCatalogDialogBody: 'Le contenu défile s’il ne tient pas, et les actions sont en bas, à 72 px.',
        uiCatalogToasts: 'Alertes',
        uiCatalogChips: 'États',
        uiCatalogTiles: 'Tuiles',
        uiCatalogChipsHint: 'Deux formes de la même étiquette. Choisis selon la façon dont elle sera lue : d’un coup d’œil, ou sur un écran où le texte dit déjà l’état.',
        uiCatalogChipsContainer: 'En conteneur',
        uiCatalogChipsContainerHint: 'Pour un écran délibéré, où le texte dit l’état. Avec des reflets, un conteneur sombre perd sa couleur : il ne va jamais seul pour quelque chose d’urgent.',
        uiCatalogChipsSolid: 'Pleines',
        uiCatalogChipsSolidHint: 'Pour lire d’un coup d’œil ou pour une urgence : un badge sur une carte, un retard.',
        uiCatalogTilesHint: 'Un grand bouton qui est une carte : son icône dans le bleu d’action et ses mots. La tuile choisie, dans le bleu de sélection avec son contour.',
        uiCatalogTileStacked: 'Empilée : pour une grille de choix',
        uiCatalogTileRow: 'En ligne : l’icône à côté des mots',
        uiCatalogTileFar: 'En ligne, à lire à un mètre',
        uiCatalogEmpty: 'Vide et hors connexion',
        uiCatalogEmptyHint: 'Ce que dit une liste quand elle n’a rien à montrer ou n’y accède pas : une icône immobile, ce qui se passe et, s’il y en a une, ce qu’il faut faire.',
        uiCatalogEmptyTitle: 'Rien à afficher',
        uiCatalogEmptyText: 'Dès qu’il y aura quelque chose, ça apparaîtra ici.',
        uiCatalogOfflineTitle: 'Hors connexion',
        uiCatalogOfflineText: 'La tablette n’accède pas à internet. Quand la connexion revient, appuie sur Réessayer.',
        uiCatalogSpinner: 'Chargement',
        uiCatalogSpinnerHint: 'Progression sans mesure : l’icône tourne tant que l’app essaie encore et les mots disent quoi. Avec « supprimer les animations », elle reste immobile.',
        uiCatalogLoading: 'Chargement…',
        uiCatalogSampleNotification: 'Tester la notification',
        uiCatalogSampleTitle: 'Message de test',
        uiCatalogSampleBody: 'Voici à quoi ressemble un message que Bronze envoie à la tablette. C’est un test : aucune réponse n’est envoyée.',
        uiCatalogSampleYes: 'Oui',
        uiCatalogSampleNo: 'Non',
        settingsAdvanced: 'Avancé',
        debugHint: 'Tests de caméra pour le support',
        debugLane: 'Écran de service',
        debugLaneHint: 'S’applique au rechargement de l’app',
        demoMode: 'Mode démo',
        demoModeHint: '3 commandes simulées ; rien n’est envoyé',
        demoActive: 'Actif : {category} · rien n’est envoyé',
        demoRestart: 'Redémarrer la démo',
        demoRestartHint: 'Commandes à zéro, même type ou un autre',
        demoPickerTitle: 'Quel type de restaurant ?',
        demoPickerHint: 'Nous chargeons 3 commandes simulées de ce type. Rien n’est envoyé.',
        demoCategoryPizza: 'Pizzas',
        demoCategoryBurger: 'Burgers',
        demoCategoryChicken: 'Poulet frit',
        demoCategorySushi: 'Sushi',
        debugLaneStore: 'Selon le restaurant',
        debugLaneSystem: 'La nouvelle',
        debugLaneCurrent: 'L’actuelle',
        queueEmpty: 'Tout est envoyé',
        queueEmptyHint: 'Aucune photo n’attend d’être envoyée.',
        changelogTagNew: 'Nouveau',
        changelogTagImproved: 'Amélioration',
        changelogTagIntegration: 'Intégration',
        changelogTagFixed: 'Corrigé'
      },
      primevue: {
        aria: {
          close: 'Fermer'
        },
        emptyMessage: 'Aucune option disponible',
        emptyFilterMessage: 'Aucun résultat',
        emptySearchMessage: 'Aucun résultat',
        emptySelectionMessage: 'Aucune sélection',
        searchMessage: '{0} résultats disponibles',
        selectionMessage: '{0} sélectionnés'
      }
    },
    pt: {
      message: {
        settings: 'Definições',
        deviceId: 'Dispositivo',
        restaurant: 'Restaurante',
        cameraPermission: 'Permissão da câmara',
        flipVertically: 'Modo Periscópio™',
        flipVerticallyHint: 'Endireita a imagem do suporte com espelho',
        periscopeTutorialTitle: 'Colocar o periscópio',
        periscopeTutorialExit: 'Sair',
        periscopeTutorialStepOf: 'Passo {step} de {total}',
        periscopeTutorialBack: 'Voltar',
        periscopeTutorialReplay: 'Ver outra vez',
        periscopeTutorialSettings: 'Como colocar o Periscópio™',
        periscopeTutorialSettingsHint: 'Guia passo a passo com a sua câmara',
        photoVideoTutorialSettings: 'Como tirar boas fotos',
        photoVideoTutorialSettingsHint: 'Vídeo · {duration}',
        photoVideoTutorialTitle: 'Como tirar boas fotos',
        photoVideoTutorialClose: 'Fechar',
        photoVideoTutorialRemaining: 'Faltam {time}',
        photoVideoTutorialLoading: 'A carregar o vídeo…',
        photoVideoTutorialPause: 'Pausa',
        photoVideoTutorialPlay: 'Reproduzir',
        photoVideoTutorialReplay: 'Ver outra vez',
        photoVideoTutorialRestart: 'Desde o início',
        photoVideoTutorialErrorTitle: 'Não foi possível carregar o vídeo',
        photoVideoTutorialErrorBody: 'Verifica a ligação à internet e tenta novamente.',
        photoVideoTutorialRetry: 'Tentar novamente',
        periscopeTutorialWelcomeTitle: 'Vamos colocar o periscópio',
        periscopeTutorialWelcomeBody: 'É o espelho que fica colado no canto do tablet, por cima da câmara. Demora uns minutos.',
        periscopeTutorialWelcomeNote: 'Só aparece à primeira vez neste tablet. Também o tens nas Definições.',
        periscopeTutorialWelcomeStart: 'Começar',
        periscopeTutorialWelcomeAlready: 'Já está colocado',
        periscopeTutorialNeedsTitle: 'Antes de começar, procura isto',
        periscopeTutorialNeedsBody: 'Na caixa só vem o periscópio. O resto arranjas tu.',
        periscopeTutorialNeedsPeriscope: 'O periscópio',
        periscopeTutorialNeedsAlcohol: 'Álcool ou desengordurante',
        periscopeTutorialNeedsCloth: 'Um pano',
        periscopeTutorialNeedsPencil: 'Um lápis ou marcador',
        periscopeTutorialNeedsNext: 'Já tenho',
        periscopeTutorialCleanTitle: 'Limpa o canto da câmara',
        periscopeTutorialCleanBody: 'Põe álcool no pano e limpa bem a zona onde vai ficar colado: a beira do tablet junto à câmara.',
        periscopeTutorialCleanStrong: 'Se ficar gordura, não cola.',
        periscopeTutorialCleanNext: 'Já está limpo',
        periscopeTutorialPlaceTitle: 'Põe no canto, sem colar',
        periscopeTutorialPlaceBody: 'A base na beira e o espelho por cima da câmara.',
        periscopeTutorialPlaceStrong: 'Ainda não tires o plástico vermelho.',
        periscopeTutorialPlaceInset: 'A câmara olha para o espelho e o espelho, para a mesa.',
        periscopeTutorialPlaceCamera: 'Câmara',
        periscopeTutorialPlaceMirror: 'Espelho',
        periscopeTutorialPlaceTable: 'Mesa',
        periscopeTutorialPlaceNext: 'Seguinte',
        periscopeTutorialAlignTitle: 'Mexe até só se ver a mesa',
        periscopeTutorialAlignBody: 'Aponta o espelho à mesa e mexe o periscópio aos poucos.',
        periscopeTutorialAlignStrong: 'Não pode misturar-se nada, nem em cima nem em baixo.',
        periscopeTutorialAlignNext: 'Já se vê bem',
        periscopeTutorialLiveBadge: 'Foto real · atualiza sozinha',
        periscopeTutorialLiveAlt: 'Foto real da câmara',
        periscopeTutorialLiveStarting: 'A abrir a câmara…',
        periscopeTutorialLiveError: 'Não é possível abrir a câmara.',
        periscopeTutorialLiveRetry: 'Tentar de novo',
        periscopeTutorialExampleGood: 'Bem: só a mesa',
        periscopeTutorialExampleBadBottom: 'Mal: mistura-se em baixo',
        periscopeTutorialExampleBadTop: 'Mal: mistura-se em cima',
        periscopeTutorialMarkTitle: 'Marca onde fica',
        periscopeTutorialMarkBody: 'Sem o mexer, contorna a base com o lápis: os dois lados e a parte de trás.',
        periscopeTutorialMarkNext: 'Já está marcado',
        periscopeTutorialStickTitle: 'Tira o plástico vermelho e cola',
        periscopeTutorialStickBody: 'Põe mesmo na marca.',
        periscopeTutorialStickStrong: 'Aperta com força uns segundos.',
        periscopeTutorialStickNext: 'Já está colado',
        periscopeTutorialCheckTitle: 'Confirma que se vê bem',
        periscopeTutorialCheckBody: 'Vê-se só a mesa, sem faixas de outra coisa em cima ou em baixo?',
        periscopeTutorialCheckYes: 'Sim, vê-se bem',
        periscopeTutorialCheckNo: 'Não, é preciso mexer',
        periscopeTutorialUnstickTitle: 'Descola-o a rodar',
        periscopeTutorialUnstickBody: 'Roda o periscópio sobre si próprio, uma volta inteira, até se soltar.',
        periscopeTutorialUnstickNext: 'Já está descolado',
        periscopeTutorialRestickTitle: 'Cola-o outra vez na marca',
        periscopeTutorialRestickBody: 'Põe mesmo na marca.',
        periscopeTutorialRestickBad: 'Não cola bem',
        periscopeTutorialRetapeTitle: 'Muda a fita',
        periscopeTutorialRetapeBody: 'Compra fita adesiva de dupla face. Tira a fita velha da base e cola um pedaço novo do mesmo tamanho.',
        periscopeTutorialRetapeNext: 'Já tem fita nova',
        periscopeTutorialDoneTitle: 'Periscópio colocado!',
        periscopeTutorialDoneBody: 'Ativámos o Modo Periscópio™ para a imagem sair na posição certa.',
        periscopeTutorialDoneBody2: 'Já podes pôr o tablet no suporte.',
        periscopeTutorialDoneFinish: 'Concluir',
        immersiveViewport: 'Modo imersivo da câmara',
        immersiveViewportHint: 'A câmara em ecrã inteiro',
        immersiveViewportModalTitle: 'Modo imersivo da câmara ativado',
        immersiveViewportModalBody: 'A câmara agora aparece maior e os botões ficam por cima da imagem. Se preferires voltar à versão anterior, desativa a opção nas Definições.',
        immersiveViewportModalButton: 'Percebido',
        signOut: 'Terminar sessão',
        general: 'Geral',
        camera: 'Câmara',
        signIn: 'Iniciar sessão',
        signingIn: 'A iniciar sessão...',
        queue: 'Fila de envio',
        photo: 'Foto',
        analyze: 'Analisar',
        retakeReminder: 'Lembra-te de voltar para tirar a foto e analisar',
        retakeAimTitle: 'Tira a foto a:',
        retakeAimFoot: 'e toca em Analisar para continuar',
        avoidDuplicatePhotos: 'Lembra-te de não repetir a mesma foto',
        imagesLeftToUpload: 'Fotos por enviar',
        cancelAnalysis: 'Cancelar análise',
        back: 'Voltar',
        timeout: 'Não foi possível analisar o conteúdo do pedido.',
        accept: 'Aceitar',
        analyzing: 'A analisar o pedido',
        analysisError: 'Erro ao analisar o pedido',
        close: 'Fechar',
        checkOrder: 'Rever pedido',
        missingItems: 'Produtos em falta',
        notDetected: 'Falta {count} produto | Faltam {count} produtos',
        notDetectedSubtitleSingle: 'Revê o pedido antes de fechar o saco',
        missingCount: 'Falta {count} | Faltam {count}',
        stillContinue: 'Entregar sem corrigir',
        stillContinueWarning: 'O cliente pode reclamar',
        addPhotos: 'Corrigir e tirar outra foto',
        itemNotDetectedInPhoto: 'Um destes produtos não foi detetado | {count} destes produtos não foram detetados',
        perfect: 'Está tudo perfeito!',
        finalize: 'Concluir',
        help: 'Ajuda',
        helpPrefill: 'Olá, somos a equipa de cozinha de {store}. Precisamos de ajuda com: ',
        noOrders: 'Ainda não temos nenhum pedido',
        resolution: 'Resolução',
        cameraDefault: 'Automático',
        uploadQueue: 'Fila de envio',
        debug: 'Debug',
        version: 'Versão',
        madeWithLove: 'Feito com ❤️ em Espanha',
        confirmSignOut: 'Tens a certeza de que queres terminar a sessão?',
        reload: 'Recarregar',
        clearCache: 'Limpar cache',
        sessionExpired: 'A sessão expirou. A redirecionar para o início de sessão',
        newServiceWorker: 'Nova versão detetada. A preparar a atualização...',
        errorLoadingSettings: 'Erro ao carregar as definições',
        indexedDBCleared: 'Base de dados local limpa com sucesso',
        errorClearingIndexedDB: 'Erro ao limpar a base de dados local',
        loading: 'A carregar...',
        startupConnecting: 'A ligar ao teu restaurante…',
        loadingTakingLong: 'Está a demorar mais do que o normal',
        retryingAutomatically: 'Continuamos a tentar automaticamente. Não precisas de fazer nada.',
        startupAutoReloadIn: 'A aplicação vai reiniciar sozinha dentro de {s} s',
        startupRestarting: 'A reiniciar a aplicação…',
        startupFailedTitle: 'Sem ligação',
        startupFailedBody: 'Deixámos de tentar. Verifica o wi-fi do restaurante e toca em Tentar novamente. Se continuar a falhar, avisa o teu gerente.',
        startupDeviceMeta: 'Dispositivo: {id} · v{version}',
        retryStartup: 'Tentar novamente',
        deviceIdChanged: 'O identificador deste dispositivo mudou. Escreve o novo identificador e o respetivo código para voltares a entrar.',
        otpCode: 'Código OTP',
        needHelp: 'Precisas de ajuda?',
        loginSuccessful: 'Sessão iniciada com sucesso!',
        sessionExpiredRelogin: 'A tua sessão expirou. Inicia sessão novamente.',
        errorOccurred: 'Ocorreu um erro. Tenta novamente.',
        incorrectCredentials: 'Não foi possível iniciar sessão. Verifica o dispositivo e o código OTP.',
        userNotFound: 'Erro ao iniciar sessão: utilizador não encontrado.',
        invalidOTP: 'Erro ao iniciar sessão: código OTP inválido.',
        hideTicket: 'Ocultar',
        showTicket: 'Talão',
        listView: 'Lista',
        groupView: 'Grupo',
        allergiesLabel: 'ALERGIAS',
        commentsLabel: 'COMENTÁRIOS',
        contentNotAvailable: 'Conteúdo não disponível',
        uploadTakingTooLong: 'O envio está a demorar um pouco…',
        analysisTakingTooLong: 'A análise está a demorar mais do que devia\nVerifica a tua ligação à internet',
        unknown: 'Desconhecido',
        unknownOrder: 'Pedido desconhecido',
        messageFrom: 'Mensagem de',
        secondsRemaining: 'segundos restantes',
        justNow: 'Agora mesmo',
        minuteAgo: 'Há 1 min',
        minutesAgo: 'Há {minutes} min',
        // Camera preview literals
        initializingCamera: 'A iniciar a câmara...',
        startCamera: 'Iniciar câmara',
        cameraFaultPermissionTitle: 'Falta a permissão da câmara',
        cameraFaultPermissionBlockedBody: 'O navegador tem a câmara bloqueada para o Bronze. Toca no cadeado junto ao endereço, põe Câmara em «Permitir» e tenta novamente.',
        cameraFaultPermissionPendingBody: 'O navegador pediu permissão para usar a câmara e ninguém respondeu. Toca em «Permitir» no aviso que aparece em cima.',
        cameraFaultBusyAppTitle: 'A câmara está ocupada',
        cameraFaultBusyAppBody: 'Outra aplicação do tablet está a usar a câmara. Fecha-a nas apps recentes e tenta novamente. Se continuar na mesma, reinicia o tablet.',
        cameraFaultOtherWindowTitle: 'O Bronze está aberto duas vezes',
        cameraFaultOtherWindowBody: 'O Bronze Tracker está aberto noutra janela ou separador, e só um pode usar a câmara. Fecha o outro e tenta novamente.',
        cameraFaultNeedsTapTitle: 'Toca para ativar a câmara',
        cameraFaultNeedsTapBody: 'O navegador precisa que toques no ecrã para ligar a câmara. Toca no botão abaixo.',
        cameraFaultNoCameraTitle: 'Não foi detetada nenhuma câmara',
        cameraFaultNoCameraBody: 'Este tablet não tem nenhuma câmara disponível. Verifica se não está desativada nas definições do dispositivo.',
        cameraFaultUnknownTitle: 'Não foi possível iniciar a câmara',
        cameraFaultUnknownBody: 'Tenta novamente. Se não arrancar, reinicia o tablet e avisa o suporte com o código abaixo.',
        cameraRetryAttempt: 'A tentar novamente… ({attempt}/{total})',
        cancel: 'Cancelar',
        more: 'mais',
        photoDiscarded: 'Foto descartada',
        capturing: 'A capturar...',
        // Manual order
        manualOrderAdd: 'Adicionar pedido',
        manualOrderAddFull: 'Adicionar pedido manualmente',
        manualOrderTitle: 'Pedido manual',
        manualOrderSelectPlatform: 'De que plataforma é o pedido?',
        manualOrderEnterCode: 'Introduz o código do pedido',
        manualOrderEnterCodeN: 'Introduz o código do pedido de {n} dígitos',
        manualOrderEnterCodeCharsN: 'Introduz o código do pedido de {n} caracteres',
        manualOrderEnterOrderSuffixN: 'Introduz os últimos {n} dígitos do pedido',
        manualOrderEnterCodeDeliveroo: 'Introduz os 3 ou 4 dígitos do código (impresso com # no talão)',
        manualOrderInvalidCode: 'O código não é válido',
        manualOrderCreating: 'A criar o pedido...',
        manualOrderErrorTitle: 'Não foi possível criar o pedido',
        manualOrderError: 'Tenta novamente.',
        manualOrderExistsOpened: 'Esse pedido já existia. Já o abrimos.',
        manualOrderExistsLooking: 'A procurar o pedido...',
        manualOrderExistsOtherPlatform: 'Esse código já está registado em {platform}, não na plataforma que escolheste. Confirma a plataforma e introduz o código de novo.',
        manualOrderExistsNotFoundTitle: 'Esse pedido já existe',
        manualOrderExistsNotFoundBody: 'O código já está registado, mas não o encontramos no tablet. Toca em Ajuda e diz-nos que plataforma e que código introduziste.',
        manualOrderOwnDelivery: 'Entrega própria',
        manualOrderTakeAway: 'Take away',
        manualOrderLoadingPlatforms: 'A carregar plataformas...',
        manualOrderNoPlatforms: 'Não há plataformas configuradas para este restaurante.',
        manualOrderLoadError: 'Não foi possível carregar as plataformas. Tenta novamente.',
        manualOrderRetry: 'Tentar novamente',
        // Rider check-in
        riderArrivedTitle: 'Novo estafeta',
        riderArrivedBody: 'O estafeta do pedido {orderId} está à espera',
        riderIsHere: 'Estafeta',
        riderReminderTitle: 'Continua à espera',
        riderReminderBody: 'O estafeta do pedido {orderId} está à espera há {minutes} min',
        ridersWaiting: '{count} estafeta à espera | {count} estafetas à espera',
        riderOrderDeliveredTitle: 'Entregue',
        riderWaitMinutes: '{minutes} min à espera',
        riderJustArrived: 'Acabou de chegar',
        ridersPopupTitle: 'Estafetas',
        ridersPopupWaiting: 'À espera',
        ridersPopupDelivered: 'Entregues',
        ridersPopupEmptyWaiting: 'Não há estafetas à espera',
        ridersPopupEmptyDelivered: 'Ainda não foi entregue nenhum pedido',
        ridersPopupClose: 'Fechar',
        ridersPopupDeliveredAt: 'Entregue às {time} · há {minutes} min',
        ridersPopupDeliveredJustNow: 'Entregue às {time} · agora',
        // Photo coverage alert (local kitchen nudge)
        coverageAlertStatus: 'Último pedido sem foto | Últimos {count} pedidos sem foto',
        coverageAlertTitle: 'Voltamos às fotos?',
        coverageAlertAck: 'Sim, no próximo pedido',
        coverageAlertCant: 'Agora não podemos',
        coverageAlertReasonTitle: 'O que se passa?',
        coverageAlertBusy: 'Estamos cheios',
        coverageAlertBusyHint: 'Voltamos quando acalmar',
        coverageAlertSupport: 'O tablet tem um problema',
        coverageAlertSupportHint: 'Abrir suporte',
        coverageAlertBack: 'Voltar',
        coverageAlertDismiss: 'Fechar aviso',
        coverageSupportPrefill: 'Olá, somos a equipa de cozinha de {store}. Precisamos de ajuda com as fotos dos pedidos. Neste momento há {count} pedidos sem foto. Podem ajudar-nos?',
        coverageThanks: 'Fotos em dia. Obrigado!',
        // --- Guided flow modal (shared shell: help today, AI-wrong next) ---
        guidedFlowYes: 'Sim, já está',
        guidedFlowNo: 'Não, avisar o suporte',
        guidedFlowBack: 'Voltar',
        guidedFlowRetry: 'Tentar novamente',
        guidedFlowReloadApp: 'Recarregar a app',
        guidedFlowUnavailableTitle: 'De momento não conseguimos abrir o chat de suporte',
        guidedFlowUnavailableOffline: 'O tablet está sem ligação. Quando voltar, toca em Tentar novamente.',
        guidedFlowUnavailableMessenger: 'O chat não carregou. Experimenta recarregar a app.',
        // --- Help flow: the six one-tap topics + free text (helpFlow.js) ---
        helpFlowTitle: 'Em que podemos ajudar?',
        helpFlowTopicMissingOrder: 'Não me aparece um pedido',
        helpFlowTopicItemFlaggedPresent: 'Diz que falta um produto e está lá',
        helpFlowTopicCannotTakePhoto: 'Não consigo tirar a foto',
        helpFlowTopicSeeOrderPhotos: 'Quero ver as fotos de um pedido',
        helpFlowTopicUnexpectedOrders: 'Aparecem-me pedidos que não deviam',
        helpFlowTopicLeftWithoutPhoto: 'O pedido saiu sem foto',
        helpFlowTopicOther: 'Outra coisa',
        helpFlowTopicVoiceNote: 'Enviar uma mensagem de voz',
        helpFlowPickTitle: 'Que pedido?',
        helpFlowPickFlaggedTitle: 'Em que pedido diz que falta alguma coisa?',
        helpFlowPickNoPhotoTitle: 'Que pedido saiu sem foto?',
        helpFlowPickNoPhotoEmpty: 'Não há pedidos recentes sem foto.',
        helpFlowPickTypeCode: 'Escrever o código',
        helpFlowCodeTitle: 'Qual é o código do pedido?',
        helpFlowCodeHint: 'Está no talão ou no saco.',
        helpFlowCodePlaceholder: 'Código do pedido',
        helpFlowCodeSkip: 'Não o tenho',
        helpFlowMsgOrderTyped: 'Pedido {code} (introduzido manualmente no tablet).',
        helpFlowPickNone: 'Não está na lista',
        helpFlowBadgeIncorrect: 'IA: falta produto',
        helpFlowBadgeCorrect: 'Correto',
        helpFlowBadgePending: 'Com foto, sem resultado',
        helpFlowBadgeNoPhoto: 'Sem foto',
        helpFlowWorkingReload: 'Vamos reiniciar a app…',
        helpFlowWorkingSub: 'Demora uns segundos. Quando voltar, perguntamos-te se ficou resolvido.',
        helpFlowConfirmSub: 'Recarregámos a app.',
        helpFlowConfirmMissingOrder: 'Já te aparece o pedido?',
        helpFlowConfirmCamera: 'A câmara já funciona?',
        helpFlowEvidenceOrders: 'Neste momento não há nenhum pedido no ecrã | Neste momento há 1 pedido no ecrã | Neste momento há {count} pedidos no ecrã',
        helpFlowEvidenceCameraOk: 'A câmara está a funcionar',
        helpFlowEvidenceCameraFault: 'A câmara continua a falhar: {code}',
        helpFlowResolvedToast: 'Resolvido! Se voltar a acontecer, avisa-nos.',
        helpFlowSentToast: 'Enviado ao suporte. Respondemos-te no chat.',
        helpVoiceSpeakNow: 'Fala agora. No fim, termina a gravação e toca em enviar.',
        helpVoiceTapMic: 'Se não começou a gravar, toca no microfone do chat.',
        // --- Help flow: ver las fotos de un pedido (orderPhotos.js, visor en el propio modal) ---
        helpPhotosPickTitle: 'De que pedido queres ver as fotos?',
        helpPhotosLoading: 'A procurar os últimos pedidos…',
        helpPhotosEmpty: 'Ainda não há pedidos com foto.',
        helpPhotosFailed: 'Não foi possível carregar os pedidos.',
        helpPhotosMore: 'Ver pedidos anteriores',
        helpPhotosAskSupport: 'Pedi-las ao suporte',
        helpPhotosCount: '1 foto | {count} fotos',
        helpPhotosBadgeNoResult: 'Sem resultado',
        orderPhotosCounter: 'Foto {index} de {count}',
        orderPhotosAlt: 'Foto {index} do pedido {code}',
        orderPhotosPrev: 'Foto anterior',
        orderPhotosNext: 'Foto seguinte',
        orderPhotosImageFailed: 'Não foi possível carregar a foto',
        orderPhotosLoadFailed: 'Não foi possível carregar as fotos deste pedido.',
        orderPhotosNone: 'Este pedido ainda não tem fotos no sistema.',
        orderPhotosNoneHint: 'Se acabaste de as tirar, demoram uns segundos a ser enviadas.',
        orderPhotosOtherOrders: 'Ver outros pedidos',
        orderPhotosCheckAgain: 'Verificar novamente',
        orderPhotosSupport: 'Alguma coisa não bate certo? Escrever ao suporte',
        orderPhotosJustNow: 'agora mesmo',
        orderPhotosMinutesAgo: 'há {minutes} min',
        orderPhotosYesterday: 'ontem, {time}',
        orderPhotosDate: '{date}, {time}',
        // --- Login help: mensaje contextual a soporte (loginHelp.js) ---
        loginHelpIntro: 'Olá, a equipa de cozinha não consegue iniciar sessão no tablet.',
        loginHelpAttempt: 'Está a tentar entrar com o dispositivo {device} e o código {otp}, mas não consegue.',
        loginHelpNoDevice: '(sem dispositivo)',
        loginHelpNoOtp: '(sem código)',
        loginHelpError: 'O erro que aparece: {error}.',
        loginHelpLastLogin: 'O último acesso correto neste tablet foi com {device} ({restaurant}), {age}.',
        loginHelpUnknownRestaurant: 'restaurante desconhecido',
        loginHelpNoHistory: 'Não há registo de nenhum acesso correto anterior neste tablet.',
        loginHelpJustNow: 'há um momento',
        loginHelpMinutesAgo: 'há {minutes} min',
        loginHelpHoursAgo: 'há {hours} h',
        loginHelpDaysAgo: 'há {days} dias',
        loginHelpTech: 'Login · v{version}',
        loginHelpSentToast: 'Enviado ao suporte. Respondemos-te no chat.',
        loginHelpUnavailable: 'Não foi possível abrir o chat. Verifica a ligação.',
        // The support message the composer opens with (composeHelpMessage)
        aiWrongTitle: 'O que se passou com esse produto? | O que se passou com esses produtos?',
        aiWrongWasThere: 'Estava tudo, mas não foi detetado',
        aiWrongDifferentPackaging: 'Embalei-o de forma diferente',
        aiWrongOutOfStock: 'Rutura de stock',
        aiWrongSkip: 'Fechar',
        aiWrongBack: 'Voltar',
        aiWrongSentToast: 'Obrigado, vamos passar à equipa.',
        aiWrongMsgWasThere: 'A app diz que falta um produto, mas estava tudo no saco e não foi detetado.',
        aiWrongMsgDifferentPackaging: 'A app diz que falta um produto, mas embalámo-lo de outra forma.',
        aiWrongMsgOutOfStock: 'A app diz que falta um produto, mas houve rutura de stock.',
        aiWrongMsgItems: 'Produtos que marcou como em falta: {items}.',
        helpFlowMsgIntro: 'Olá, escrevemos do Bronze Tracker (o tablet da cozinha) de {store}.',
        helpFlowMsgPlatform: 'O pedido é de {platform}.',
        helpFlowMsgOrderList: 'O pedido que não devia estar: {codes} | Os {count} pedidos que não deviam estar: {codes}',
        helpFlowPickPlatformTitle: 'De que plataforma é o pedido?',
        helpFlowPickPlatformNone: 'Não sei',
        helpFlowPickOrdersTitle: 'Quais é que não deviam estar?',
        helpFlowPickOrdersHint: 'Podes marcar mais do que um',
        helpFlowComposeTitle: 'O que se passa?',
        helpFlowComposePlaceholder: 'Conta-nos por palavras tuas…',
        helpFlowComposeSend: 'Enviar ao suporte',
        helpFlowMsgMissingOrder: 'Não nos aparece um pedido no tablet.',
        helpFlowMsgItemFlaggedPresent: 'A app diz que falta um produto, mas está no saco.',
        helpFlowMsgCannotTakePhoto: 'Não conseguimos tirar a foto.',
        helpFlowMsgSeeOrderPhotos: 'Queremos ver as fotos de um pedido.',
        helpFlowMsgSeeOrderPhotosViewed: 'Vimos as fotos deste pedido e precisamos de ajuda.',
        helpFlowMsgUnexpectedOrders: 'Aparecem-nos pedidos que não deviam estar.',
        helpFlowMsgLeftWithoutPhoto: 'Um pedido saiu sem foto.',
        helpFlowMsgVoiceNote: 'Explicamos numa mensagem de voz.',
        helpFlowMsgOrder: 'Pedido {code}',
        helpFlowMsgAnalysis: 'análise {id}',
        helpFlowMsgManualOrder: 'adicionado manualmente',
        helpFlowMsgRemedyReload: 'Já recarregámos a app e continua na mesma.',
        helpFlowMsgTech: 'Tablet {device} · v{version}',
        helpFlowMsgConnOk: 'ligação OK',
        helpFlowMsgConnOffline: 'sem ligação',
        helpFlowMsgConnDeaf: 'ligação instável',
        helpFlowMsgOrdersOnScreen: 'nenhum pedido no ecrã | 1 pedido no ecrã | {count} pedidos no ecrã',
        helpFlowMsgWithoutPhoto: 'nenhum sem foto | 1 sem foto | {count} sem foto',
        helpFlowMsgCodes: 'No ecrã: {codes}',
        helpFlowMsgManualCount: '1 adicionado manualmente | {count} adicionados manualmente',
        helpFlowMsgCameraFault: 'Câmara: falha {code}',
        helpFlowMsgCameraOk: 'Câmara OK ({width}×{height})',
        helpFlowMsgCameraNoPermission: 'Câmara: sem permissão',
        helpFlowMsgCameraPermissionPending: 'Câmara: permissão sem resposta',
        helpFlowMsgCameraRunning: 'Câmara a funcionar',
        helpFlowMsgCameraStarting: 'Câmara: a arrancar ou ainda sem imagem',
        helpFlowMsgCameraCount: 'nenhuma câmara detetada | 1 câmara detetada | {count} câmaras detetadas',
        helpFlowMsgCameraResolution: 'qualidade {resolution}px',
        cameraCaptureMethod: 'Método de captura',
        cameraCaptureMethodHint: 'Sensor, só se a foto cortar o tabuleiro',
        signOutHint: 'Para voltar, vai precisar do código',
        cameraHint: 'Automático usa a traseira',
        photoAndAnalyze: 'Foto e analisar',
        retakeReminderTitle: 'Pedido {code} por corrigir',
        retakeReminderBody: 'Volta a abri-lo, tira a foto e toca em Analisar.',
        orderPhotosLoading: 'A carregar as fotos…',
        orderPhotosOffline: 'Sem ligação',
        cameraCaptureMethodImageCaptureShort: 'Sensor',
        cameraCaptureMethodCanvasShort: 'Rápido',
        blackImageTitle: 'Não foi possível tirar a foto',
        blackImageBody: 'Verifica se nada está a tapar a câmara e tenta novamente.',
        orderStateCorrect: 'Correto',
        orderStateWrong: 'Incorreto',
        orderStateQueued: 'Em fila',
        orderPhotoCount: '{count} foto | {count} fotos',
        takePhoto: 'Tirar a foto',
        uiCatalogOpen: 'Sistema de design',
        uiCatalogTitle: 'Sistema de design',
        uiCatalogIntro: 'As cores, a tipografia e os componentes da app, tal como se veem neste tablet.',
        uiCatalogFont: 'Tipografia',
        uiCatalogFontHint: 'Comparação: muda a letra até recarregares. As que não são DM Sans precisam de ligação.',
        uiCatalogFontSystem: 'A do sistema',
        uiCatalogFontBrand: 'DM Sans (a escolhida)',
        uiCatalogPalette: 'Paleta de cores',
        uiCatalogPaletteHint: 'Comparação: muda as cores até recarregares.',
        uiCatalogPaletteBronze: 'Bronze (aprovada)',
        uiCatalogPaletteCurrent: 'A anterior',
        uiCatalogRamps: 'Paleta Bronze',
        uiCatalogRampsHint: 'Cada cor nos seus passos, do 1 (o mais escuro) ao 12. O 9 é o preenchimento: no azul e no amarelo é a cor exata da marca (com contorno), e o resto é calculado a partir dela.',
        uiCatalogRampNames: {
            grey: 'Cinzento · fundos, cartões e texto',
            blue: 'Azul · ação e pedido por fotografar',
            bronze: 'Amarelo Bronze · marca',
            green: 'Verde · correto',
            orange: 'Laranja bronze · incorreto',
            amber: 'Âmbar · aviso e atraso',
            red: 'Vermelho · estafeta e terminar sessão',
            slate: 'Ardósia · em fila',
        },
        uiCatalogBrand: 'O amarelo da marca, junto aos estados',
        uiCatalogBrandHint: 'Só como preenchimento, nas superfícies da marca (arranque, login, novidades) e nunca junto ao semáforo. Aqui, ao lado de «rever» e do atraso, para veres que não se confundem.',
        uiCatalogVision: 'Ver como',
        uiCatalogVisionHint: 'Simula como parte da cozinha vê as cores, até saíres deste ecrã. As listas que se abrem não são simuladas.',
        uiCatalogVisionNames: {
            normal: 'Visão normal',
            deuteranopia: 'Deuteranopia (verde)',
            protanopia: 'Protanopia (vermelho)',
            tritanopia: 'Tritanopia (azul)',
            achromatopsia: 'Sem cor',
            glare: 'Com reflexo da cozinha',
        },
        uiCatalogTrafficLight: 'Semáforo de pedidos',
        uiCatalogTrafficLightHint: 'Como ficariam os cartões da lista de pedidos: cada estado com a sua cor, o seu ícone e a sua palavra. Com «Ver como» leem-se com daltonismo ou com reflexo.',
        uiCatalogStateTodo: 'Por fotografar',
        uiCatalogStatePending: 'Em fila',
        uiCatalogColors: 'Cor',
        uiCatalogType: 'Tipografia',
        uiCatalogTypeSample: 'Pedido pronto a entregar',
        uiCatalogButtons: 'Botões',
        uiCatalogPrimary: 'Ação principal',
        uiCatalogSecondary: 'Outra ação',
        uiCatalogText: 'Ligação',
        uiCatalogOutlined: 'Contorno',
        uiCatalogWithIcon: 'Com ícone',
        uiCatalogIcons: 'Ícones',
        uiCatalogLists: 'Listas e controlos',
        uiCatalogGroup: 'Um grupo',
        uiCatalogDialog: 'Diálogo',
        uiCatalogOpenDialog: 'Abrir um diálogo de exemplo',
        uiCatalogDialogEyebrow: 'Exemplo',
        uiCatalogDialogTitle: 'Um diálogo do sistema',
        uiCatalogDialogSubtitle: 'Título, subtítulo e o seu X',
        uiCatalogDialogBody: 'O corpo desloca-se se não couber, e as ações ficam em baixo, a 72 px.',
        uiCatalogToasts: 'Avisos',
        uiCatalogChips: 'Estados',
        uiCatalogTiles: 'Mosaicos',
        uiCatalogChipsHint: 'Duas formas da mesma etiqueta. Escolhe pela forma como vai ser lida: num relance, ou num ecrã onde o texto já diz o estado.',
        uiCatalogChipsContainer: 'Em contentor',
        uiCatalogChipsContainerHint: 'Para um ecrã deliberado, onde o texto diz o estado. Com reflexo, um contentor escuro perde a cor: nunca vai sozinho para algo urgente.',
        uiCatalogChipsSolid: 'Sólidas',
        uiCatalogChipsSolidHint: 'Para ler num relance ou algo urgente: um distintivo sobre um cartão, um atraso.',
        uiCatalogTilesHint: 'Um botão grande que é um cartão: o ícone no azul de ação e as suas palavras. O escolhido, no azul de seleção e com o seu contorno.',
        uiCatalogTileStacked: 'Empilhado: para uma grelha de opções',
        uiCatalogTileRow: 'Em linha: o ícone junto às palavras',
        uiCatalogTileFar: 'Em linha, para ler a um metro',
        uiCatalogEmpty: 'Vazio e sem ligação',
        uiCatalogEmptyHint: 'O que diz uma lista quando não tem nada para mostrar ou não lá chega: um ícone parado, o que se passa e, se houver, o que fazer.',
        uiCatalogEmptyTitle: 'Não há nada para mostrar',
        uiCatalogEmptyText: 'Quando houver alguma coisa, aparece aqui.',
        uiCatalogOfflineTitle: 'Sem ligação',
        uiCatalogOfflineText: 'O tablet não chega à internet. Quando voltar, toca em Tentar novamente.',
        uiCatalogSpinner: 'A carregar',
        uiCatalogSpinnerHint: 'Progresso sem medida: o ícone gira enquanto a app continua a tentar e as palavras dizem o quê. Com «remover animações» fica parado.',
        uiCatalogLoading: 'A carregar…',
        uiCatalogSampleNotification: 'Experimentar a notificação',
        uiCatalogSampleTitle: 'Mensagem de teste',
        uiCatalogSampleBody: 'É assim que se vê uma mensagem que a Bronze envia para o tablet. Esta é de teste: não é enviada nenhuma resposta.',
        uiCatalogSampleYes: 'Sim',
        uiCatalogSampleNo: 'Não',
        settingsAdvanced: 'Avançado',
        debugHint: 'Testes de câmara para o suporte',
        debugLane: 'Ecrã de serviço',
        debugLaneHint: 'Aplica-se ao recarregar a app',
        demoMode: 'Modo demo',
        demoModeHint: '3 pedidos simulados; não é enviado nada',
        demoActive: 'Ativo: {category} · não é enviado nada',
        demoRestart: 'Reiniciar demo',
        demoRestartHint: 'Pedidos do zero, do mesmo tipo ou outro',
        demoPickerTitle: 'Que tipo de restaurante?',
        demoPickerHint: 'Carregamos 3 pedidos simulados desse tipo. Não é enviado nada.',
        demoCategoryPizza: 'Pizzas',
        demoCategoryBurger: 'Hambúrgueres',
        demoCategoryChicken: 'Frango frito',
        demoCategorySushi: 'Sushi',
        debugLaneStore: 'Conforme a loja',
        debugLaneSystem: 'O novo',
        debugLaneCurrent: 'O atual',
        queueEmpty: 'Tudo enviado',
        queueEmptyHint: 'Não há fotos à espera de envio.',
        cameraCaptureMethodImageCapture: 'Sensor (mais campo, mais lento)',
        cameraCaptureMethodCanvas: 'Rápido (o que vês no ecrã)',
        cameraPhotoResolution: 'Resolução das fotos',
        cameraPhotoResolutionHint: 'Mais alta: mais nítida, envio mais lento',
        cameraPhotoResolutionLow: 'Baixa',
        cameraPhotoResolutionMedium: 'Média',
        cameraPhotoResolutionHigh: 'Alta',
        cameraPhotoResolutionRecommended: 'recomendada',
        cameraExposureComp: 'Compensação de exposição',
        cameraExposureCompHint: 'Menos se sair queimado, mais se sair escuro',
        // Black image detection
        retryingCapture: 'A repetir a captura...',
        blackImageDetected: 'Não foi possível capturar a foto. Verifica se a câmara não está tapada e tenta novamente.',
        blackImageDetection: 'Detetar fotos pretas',
        blackImageDetectionHint: 'Repete sozinha as fotos pretas, até 2 vezes',
        // Camera / analysis error popups
        uploadPhotosError: 'Não foi possível enviar todas as fotos. Tenta novamente.',
        analysisIdNotFound: 'Não foi encontrado o ID de análise do pedido',
        analysisSaveError: 'Erro ao guardar o resultado da análise no IndexedDB',
        analysisFailedRetry: 'Não foi possível analisar o pedido. Tenta novamente: toca no botão Analisar.',
        analysisQueuedOffline: 'Pedido {id}: sem ligação, será analisado quando voltar a ligação.',
        analysisQueuedUploading: 'Pedido {id}: a enviar fotos, será analisado no fim.',
        continueInBackground: 'Continuar em segundo plano',
        bgAnalysisCorrect: 'Pedido {id}: correto',
        bgAnalysisMissingDetail: 'Pedido {id}: {summary}',
        bgAnalysisIncorrect: 'Pedido {id}: faltam produtos, rever',
        missingVerb: 'falta | faltam',
        missingOthers: 'outro produto | outros {count} produtos',
        and: 'e',
        tagOffline: 'Sem ligação',
        tagUploading: 'A enviar',
        tagCorrect: 'Correto',
        tagReview: 'Rever',
        qrScanPartial: 'A leitura chegou cortada. Lê o talão outra vez.',
        qrScanDeliveredTitle: 'Entregue ao estafeta',
        qrScanAlreadyTag: 'Já entregue',
        qrScanAlreadyBody: 'Este pedido já estava fechado',
        qrScanNotHere: 'Esse talão não é desta loja. Nenhum pedido foi fechado.',
        qrScanOffline: 'Sem ligação: não foi possível verificar o pedido. Lê o talão outra vez.',
        qrScanNotSavedTag: 'Não guardado',
        qrScanNotSavedBody: 'A entrega não chegou ao servidor. Volta a tentar quando houver ligação, ou lê outra vez.',
        qrScanUnknown: 'O leitor leu um código que não é de pedido: {text}',
        qrGunTutorialGroup: 'Leitor QR',
        qrGunTutorialSettings: 'Como ligar e usar o leitor',
        qrGunTutorialSettingsHint: 'Emparelhá-lo e fechar pedidos a ler o talão',
        qrGunTutorialTitle: 'Leitor QR',
        qrGunTutorialExit: 'Sair',
        qrGunTutorialStepOf: 'Passo {step} de {total}',
        qrGunTutorialNext: 'Seguinte',
        qrGunTutorialBack: 'Voltar',
        qrGunTutorialReplay: 'Ver outra vez',
        qrGunTutorialPowerTitle: 'Liga o leitor',
        qrGunTutorialPowerBody: 'Carrega no gatilho.',
        qrGunTutorialPowerStrong: 'Assim o tablet consegue encontrá-lo.',
        qrGunTutorialPairTitle: 'Liga-o ao tablet',
        qrGunTutorialPairBody: 'Abre as Definições do tablet → Bluetooth e toca no que começa por «Hyper 160S».',
        qrGunTutorialPairNote: 'Aparece com um ícone de teclado. Quando disser «Ligado», está pronto.',
        qrGunTutorialBtTitle: 'Bluetooth',
        qrGunTutorialBtVisible: 'Atualmente visível para dispositivos próximos.',
        qrGunTutorialBtPaired: 'Dispositivos emparelhados',
        qrGunTutorialBtAvailable: 'Dispositivos disponíveis',
        qrGunTutorialBtConnected: 'Ligado',
        qrGunTutorialPairNotFound: 'Não aparece',
        qrGunTutorialNotfoundTitle: 'Se não aparecer',
        qrGunTutorialNotfoundBody: 'Carrega no gatilho para ligar o leitor e espera uns segundos.',
        qrGunTutorialNotfoundNote: 'Depois volta a ver a lista de Bluetooth.',
        qrGunTutorialNotfoundRetry: 'Procurar outra vez',
        qrGunTutorialBackTitle: 'Volta ao Bronze',
        qrGunTutorialBackBody: 'Abre outra vez o Bronze Tracker. Funciona como sempre.',
        qrGunTutorialBackNote: 'Agora o teclado é o leitor. Se precisares de escrever, toca no ícone que aparece à esquerda do ecrã para mostrar o teclado.',
        qrGunTutorialScanTitle: 'Lê o saco',
        qrGunTutorialScanBody: 'Quando acabares um pedido, aponta o leitor ao QR do talão do saco e carrega no gatilho.',
        qrGunTutorialScanStrong: 'Assim o pedido fica entregue ao estafeta.',
        qrGunTutorialNotifyTitle: 'O tablet avisa-te',
        qrGunTutorialNotifyBody: 'Toca um som e aparece «Entregue ao estafeta» com o número do pedido.',
        qrGunTutorialNotifyNote: 'O leitor também apita ao ler: esse apito só diz que leu.',
        qrGunTutorialNotifyListen: 'Ouvir o som',
        qrGunTutorialSleepTitle: 'Se adormecer, acorda-o',
        qrGunTutorialSleepBody: 'Passados uns 10 minutos sem o usar, o leitor desliga-se sozinho.',
        qrGunTutorialSleepStrong: 'Carrega no gatilho: num segundo volta a ligar-se e apita. Não está avariado.',
        qrGunTutorialTestTitle: 'Experimenta',
        qrGunTutorialTestBody: 'Aponta o leitor a este código e carrega no gatilho.',
        qrGunTutorialTestNote: 'Sobe o brilho do tablet ao máximo: com pouco brilho o leitor não lê o ecrã. Nenhum pedido é fechado.',
        qrGunTutorialTestSkip: 'Continuar mesmo assim',
        qrGunTutorialTestWaiting: 'À espera do leitor…',
        qrGunTutorialTestSuccess: 'Funciona! O leitor está ligado.',
        qrGunTutorialTestOther: 'Isso não é um código do Bronze. Lê o do ecrã.',
        qrGunTutorialTestPartial: 'A leitura chegou cortada. Lê outra vez.',
        qrGunTutorialDoneTitle: 'Pronto',
        qrGunTutorialDoneBody: 'O leitor está pronto para fechar pedidos.',
        qrGunTutorialDoneFinish: 'Concluir',
        bodyQueuedOffline: 'Analisado quando voltar a ligação',
        bodyQueuedUploading: 'Analisado no fim do envio',
        reviewGeneric: 'Faltam produtos',
        // Changelog modal — content comes localised from the feed; these are the chrome.
        changelogTitle: 'Novidades',
        changelogAck: 'Percebido',
        changelogSeeAll: 'Ver todas as novidades',
        changelogSettingsHint: 'As novidades de cada versão',
        changelogTagNew: 'Novo',
        changelogTagImproved: 'Melhoria',
        changelogTagIntegration: 'Integração',
        changelogTagFixed: 'Corrigido'
      },
      primevue: {
        aria: {
          close: 'Fechar'
        },
        emptyMessage: 'Não há opções disponíveis',
        emptyFilterMessage: 'Sem resultados',
        emptySearchMessage: 'Sem resultados',
        emptySelectionMessage: 'Nada selecionado',
        searchMessage: '{0} resultados disponíveis',
        selectionMessage: '{0} selecionados'
      }
    }
  }
